import { UserRoleNames, Users } from "src/app/core/models/users";
import { UserService } from "./../../../../core/services/user.service";
import {
  Component,
  OnInit,
  OnDestroy,
  ViewChild,
  ElementRef,
} from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { ActivatedRoute, Router } from "@angular/router";
import { NavigationService } from "../../../../core/services/navigation.service";
import { JobsService } from "src/app/core/services/jobs.service";
import {
  catchError,
  exhaustMap,
  filter,
  finalize,
  interval,
  lastValueFrom,
  map,
  Observable,
  of,
  Subject,
  Subscription,
  takeUntil,
  tap,
} from "rxjs";
import { Application } from "../../../../core/models/application";
import { ApplicationService } from "../../../../core/services/application.service";
import { StorageService } from "../../../../core/services/storage.service";
import { AuthenticationService } from "../../../../core/services/authentication.service";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ConvergeJobComponent } from "../../modals/jobDialogs/converge-job/converge-job.component";
import { DatePipe, formatDate } from "@angular/common";
import {
  ApplicationVersionDictionary,
  Job,
  JobAction,
  JobActionsText,
  JobActionsValue,
  JobGlobalState,
  OutputDownloadStatus,
} from "src/app/core/models/job";
import { AbaqusJobComponent } from "../../modals/jobDialogs/abaqus-job/abaqus-job.component";
import { StarccmJobComponent } from "../../modals/jobDialogs/starccm-job/starccm-job.component";
import { CfxJobComponent } from "../../modals/jobDialogs/cfx-job/cfx-job.component";
import { FluentJobComponent } from "../../modals/jobDialogs/fluent-job/fluent-job.component";
import { MechanicalJobComponent } from "../../modals/jobDialogs/mechanical-job/mechanical-job.component";
import { LsDynaJobComponent } from "../../modals/jobDialogs/ls-dyna-job/ls-dyna-job.component";
import { CommandJobComponent } from "../../modals/jobDialogs/command-job/command-job.component";
import { JobOutputDialogComponent } from "../../modals/jobActions/job-output-dialog/job-output-dialog.component";
import { JobConfirmationDialogComponent } from "../../modals/jobActions/job-confirmation-dialog/job-confirmation-dialog.component";
import { JobPriorityDialogComponent } from "../../modals/jobActions/job-priority-dialog/job-priority-dialog.component";
import { RunJobCommandComponent } from "../../modals/jobActions/run-job-command/run-job-command.component";
import { MscActranComponent } from "../../modals/jobDialogs/msc-actran/msc-actran.component";
import { OptistructComponent } from "../../modals/jobDialogs/optistruct/optistruct.component";
import { OptisComponent } from "../../modals/jobDialogs/optis/optis.component";
import { RadiossComponent } from "../../modals/jobDialogs/radioss/radioss.component";
import { HfssComponent } from "../../modals/jobDialogs/hfss/hfss.component";
import { NanoFluidXComponent } from "../../modals/jobDialogs/nano-fluid-x/nano-fluid-x.component";
import { MscNastranJobComponent } from "../../modals/jobDialogs/msc-nastran-job/msc-nastran-job.component";
import { DynamicJobComponent } from "../../modals/jobDialogs/dynamic-job/dynamic-job.component";
import { SyncConfigService } from "src/app/core/services/sync-config.service";
import {
  CloudTypes,
  Entities,
  HpcJobStageNames,
  HpcVMStates,
  ImportCSVType,
  JobTypes,
  OperationStatus,
} from "src/app/core/models/globals";
import { DeploymentService } from "../../../../core/services/deployment.service";
import { JobChartDialogComponent } from "../../modals/jobActions/job-chart-dialog/job-chart-dialog.component";
import { NgxSpinnerService } from "ngx-spinner";
import { HeaderService } from "src/app/core/services/header.service";
import { EnvironmentService } from "../../../../core/services/environment.service";
import { StorageOracleService } from "src/app/core/services/storage-oracle.service";
import { StorageDataTransferService } from "src/app/core/services/storage-data-transfer.service";
import { EditColoumsComponent } from "../../../node/modals/edit-coloums/edit-coloums.component";
import { UserSetting } from "../../../../core/models/userSetting";
import { ResizableComponent } from "src/app/core/directive/resizable/resizable.component";
import { UtilityService } from "src/app/core/services/utility.service";
import { EditQueryComponent } from "../../../shared/components/edit-query/edit-query.component";
import { ReorderQueuedJobsComponent } from "../../modals/jobActions/reorder-queued-jobs/reorder-queued-jobs.component";
import { ImportJobsComponent } from "../../modals/jobActions/import-jobs/import-jobs.component";
import { FormControl } from "@angular/forms";
import { JobAdvanceViewComponent } from "../job-advance-view/job-advance-view.component";
import { AimlJobComponent } from "../../modals/jobDialogs/aiml-job/aiml-job.component";
import { CustomAction } from "src/app/core/models/customAction";
import { ConfirmDialogComponent } from "src/app/modules/shared/components/confirm-dialog/confirm-dialog.component";
import { TerminalComponent } from "src/app/core/header/dialogs/terminal/terminal.component";
import { MatMenuTrigger } from "@angular/material/menu";
import { JobPartitionDialogComponent } from "../../modals/jobActions/job-partition-dialog/job-partition-dialog.component";

@Component({
  selector: "job-list",
  templateUrl: "./job-list.component.html",
  styleUrls: ["./job-list.component.scss"],
})
export class JobListComponent implements OnInit, OnDestroy {
  selectedStatuses: string[] = [];
  statuses = [
    { name: "Active", id: "Active" },
    { name: "Cancelled", id: "Cancelled" },
    { name: "Cancelling", id: "Cancelling" },
    { name: "Failed", id: "Failed" },
    { name: "Queued", id: "Queued" },
    { name: "Running", id: "Running" },
    { name: "Succeeded", id: "Succeeded" },
    { name: "Waiting", id: "Waiting" },
    { name: "Hold", id: "Hold" },
  ];
  isQueryActive: boolean = false;
  queryString: string = "";
  filterText: string = "";
  active: number;
  deployment: any;
  depName: string =
    this.route.snapshot.params["deploymentName"] ||
    this.route.parent.snapshot.params["deploymentName"]; //deployment name
  clickedDepName: string = "";
  jobName;
  tempJobName;
  currentEntity;
  navRoute;
  nestedAppNames = [];
  jobNodeName: string; // contains nodename of active job
  currentUser: string = this.authenticationService.currentUserValue.username;
  userRole: string = this.authenticationService.currentUserValue.role;
  filterUser: string = this.getInitialFilterUser();// filter
  jobWorkDir: string; // contains path of job's workstore directory
  jobSyncDir: string; // contains path of job's syncstore directory
  filterApplication: string = "All"; // filter
  filterVersion: string = "All"; //filter
  filterStatus: string = "All"; // filter
  filterCores: string = "All"; // filter
  filterNodes: string = "All";
  filterNodeGroup: string = "All";
  updateJobDetail: boolean = false; // service which will update job details when new job is clicked or added
  serialNoSort: boolean = false; // filter
  jobSort: boolean = false; // filter
  userSort: boolean = false; // filter
  coresSort: boolean = false; // filter
  filtersApplied: boolean = false; // filter
  timeCreateSort: boolean = false; // filter
  timeEndSort: boolean = false; // filter
  activeSort: string = "none"; // foing if any sort is active while, used when auto refreshing data
  toShow: boolean = false; // to show job details/sync/work
  available: boolean = true; // if jobs are available
  afterSubmitReload: boolean; // variable for refreshing the data after job is subimitted
  jobs: Job[] = []; // contains list of jobs available
  jobsCopy: Job[] = [];
  apps: Application[]; // contains list of applications
  availableAppsWithVersions: ApplicationVersionDictionary;
  uniqueApps: Application[] = [];
  uniqueAppNames: Set<string> = new Set();
  nonNestedAppNames = [];
  actions: JobAction[]; // cotains all actions related to job
  jobUsers: string[]; // contains list of users
  dataReloadSubscription: Subscription; // subscription for reloading/ refreshing data every 10seconds
  loadJobSub: Subscription; // subscription for outgoing http request
  universalSub: Subscription; // subscription used for getting applications, users, active, etc data
  allJobsForAllUsers = this.env.envVariables.allJobsForAllUsers || false;
  JupyterHubUrl = this.env.envVariables.JupyterHubUrl;
  isGlobalAdmin: boolean = this.authenticationService.isUserGlobalAdmin;
  isReader: boolean = this.userRole === UserRoleNames.Reader;

  highlightClickedJob: number = 0; // highlights the active job selected ( recognized with the job number )
  tempSelectedJobPage: number = 1; // temporary vriable for storing the page no. where job is selected
  tempSelectedJobIndex: number = 0; // ''' selected job index
  datePipe: DatePipe = new DatePipe("en-US");
  currentStorageName: string = this.storageService.getActiveStorageName();
  syncStoreUsage: string;
  workStoreUsage: string;
  arr: number[];
  getUserDetailsSub: Subscription;
  userName: string;
  users: Users;
  jobEntries: number[] = [];
  jobCount: number = 0;
  entries: number = 0;
  startRange: number = 1;
  cloudType: string =
    this.route.snapshot.params["cloudType"] ||
    this.route.parent.snapshot.params["cloudType"];
  coresList: number[];
  fileUploadHeadNodeIP: string | null;
  autoRescaleFlag: boolean = this.deploymentService.getRescaleFlagOfDeployment(
    this.depName
  );
  varSubs: Subscription;
  activeJobCores: number = 0;
  columnInfo: {
    columnsOfComponents: string[];
    coloumToShow: string[];
  };
  tableName: string = "jobList";
  columnList: string[] = ["First Name", "Last Name"];
  editedColumnList: string[] = [];
  checkList: any;
  statusItems: any = [];
  functionReference: any;
  entriesNumber: number = 18;
  shortStringVal: number = 25; // for shortening the string
  isMonitor: boolean =
    this.authenticationService.currentUserValue.role == UserRoleNames.Reader
      ? true
      : false;
  isLocalStoreEnabled: boolean = this.deploymentService.isLocalStoreEnabled(
    this.depName
  );
  jobRetrievalRange: number = 500;
  previousFilterUser = this.filterUser;
  toShowFilter: boolean = false;
  jobViewOpen: boolean = false;
  selectedJob: Job | null = null;
  isDropdownOpen = false;
  jobsCountToShow: Number = 18;
  p: Number = 1;
  allowAdminJobActionsToUsers = this.env.envVariables.allowAdminJobActions;
  destroy$ = new Subject<void>();
  config = {
    itemsPerPage: 18,
    currentPage: 1,
  };
  editQuerySpinnerFlag: boolean = false;

  nodeList: String[];
  nodeGroupsList: String[];
  todayDate = new Date();
  dateTimePeriod = new FormControl();
  endDate: Date = null;

  loadPerUserJobs$ = new Subject<number>();
  UniAppNames: string[];
  selectedJobIds: string[] = [];
  advancedViewLength = 80;
  currentValue = 80;
  customActions: CustomAction[] = [];
  repoUrl: string = "";
  repoName: string = "";
  currentCustomActions: JobAction[] = [];
  timeSort: boolean = true;
  @ViewChild("childs") private bottomStorage: ElementRef;
  @ViewChild("jobNameHead") elementView: ResizableComponent;
  @ViewChild("jobHeadRow") elementRow;
  @ViewChild("advanceView") advanceView: JobAdvanceViewComponent | null;
  @ViewChild('menuTrigger') menuTrigger: MatMenuTrigger;

  constructor(
    private depService: DeploymentService,
    private router: Router,
    private route: ActivatedRoute,
    private navService: NavigationService,
    public dialog: MatDialog,
    private applicationService: ApplicationService,
    public jobService: JobsService,
    private storageService: StorageService,
    private authenticationService: AuthenticationService,
    private userService: UserService,
    private snackBar: MatSnackBar,
    private syncConfig: SyncConfigService,
    private spinner: NgxSpinnerService,
    private deploymentService: DeploymentService,
    private _headerService: HeaderService,
    private env: EnvironmentService,
    private _oracleService: StorageOracleService,
    private storageDataTransferService: StorageDataTransferService,
    private utilityService: UtilityService
  ) {
    this.dateTimePeriod.valueChanges.subscribe((selectedDates: Date[]) => {
      if (selectedDates && selectedDates.length === 2) {
        this.endDate = selectedDates[1];
        this.filterArrangeUser();
      }
    });
  }

  ngOnInit() {
    this.jobService.updateJobAction(null);
    this.columnInfo = {
      columnsOfComponents: [],
      coloumToShow: [],
    };
    this.columnInfo.columnsOfComponents = [
      "Application",
      "Version",
      "Global State",
      "Stage",
      "Status",
      "User",
      "#Cores",
      "BatchNode",
      "Node Group",
      "UserGroup",
      "Create Time",
      "End Time",
      "Run Time",
      "Tag",
    ];
    this.spinner.show("jobListLoad");
    this.getHeadNodeIp();

    if (
      this.jobService.dashboardFilterApplied !== null &&
      this.jobService.dashboardFilterApplied !== undefined
    ) {
      if (this.jobService.dashboardFilterApplied === "Completed") {
        this.selectedStatuses.push("Cancelled");
        this.selectedStatuses.push("Failed");
        this.selectedStatuses.push("Succeeded");
      } else if (this.jobService.dashboardFilterApplied === "Active") {
        this.selectedStatuses.push("Active");
        this.selectedStatuses.push("Cancelling");
        this.selectedStatuses.push("Queued");
        this.selectedStatuses.push("Running");
        this.selectedStatuses.push("Waiting");
        this.selectedStatuses.push("Hold");
      }
    }

    if (this.cloudType == CloudTypes.Oracle) {
      this._oracleService.getPreAuthenticatedUri(
        this.depName,
        this.currentStorageName
      );
    }
    this.getJobCount();
    this.ngOnChanges();
    this.getDeploymentInfo();
    this.navService.breadcrumbEntity.subscribe((x) => {
      this.currentEntity = x;
    });
    if (this.currentEntity != Entities.Jobs) {
      this.navService.sendLeftPanelIndex(3);
    } else {
      this.navService.sendLeftPanelIndex(0);
    }
    this.universalSub = this.jobService.ScrollUp.subscribe((x) => {
      if (x === true && this.bottomStorage) {
        this.bottomStorage.nativeElement.scrollTop = 0;
        this.jobService.sendScrollUpData(false);
      }
    });
    this.navService.sendParentData(Entities.Jobs);
    this.universalSub = this.jobService.ActiveTab.subscribe((value) => {
      this.active = value;
    });
    this.universalSub = this.applicationService
      .getAllApplicationsForUser(this.depName)
      .subscribe((data) => {
        this.apps = <Application[]>JSON.parse(JSON.stringify(data));
        if (this.apps != null) {
          this.apps.forEach((app: Application) => {
            if (!this.uniqueAppNames.has(app.appName)) {
              this.uniqueApps.push(app);
              this.uniqueAppNames.add(app.appName);
            }
          });

          this.nonNestedAppNames = this.uniqueApps.filter(
            (obj) => obj.templates === null || obj.templates === ""
          );
          this.nestedAppNames = this.uniqueApps.filter(
            (obj) => obj.templates !== null && obj.templates !== ""
          );
        }
      });

    try {
      this.userRole = this.allJobsForAllUsers
        ? UserRoleNames.GlobalAdmin
        : this.getUserRoleInText(
          this._headerService.getUserRoleForDeployment(this.depName)
        );
      if (this.userRole != UserRoleNames.JobOperator) {
        this.getUsersForFilter();
      }
    } catch (error) { }
    this.getColumnSetting();
    this.checkForJobActions();
    this.loadPerUserJobs$
      .pipe(
        exhaustMap(() =>
          this.fetchJobData(this.entries).pipe(
            catchError((error) => {
              console.error("API error:", error);
              // Return an empty array or handle the error gracefully
              return of([]);
            })
          )
        )
      )
      .subscribe({
        next: (data) => {
          this.handleJobResponse(data);
        },
        error: (err) => {
          console.error("Error in subscription:", err);
        },
      });
  }

  private getInitialFilterUser(): string {
    var onLoadAllJobsSelection = this.env.envVariables.onLoadAllJobsSelection;
    if (!this.allJobsForAllUsers && this.userRole == UserRoleNames.JobOperator) {
      return this.currentUser;
    }
      return onLoadAllJobsSelection ? "All" : this.currentUser;
  }

  fetchJobData(entries: number) {
    // Encapsulate the API call logic here
    return this.jobService.getJobPerUser(
      this.depName,
      this.filterUser,
      entries,
      this.allJobsForAllUsers,
      this.isQueryActive,
      this.queryString
    );
  }

  checkIfFromPod() {
    this.route.children.forEach((child) => {
      child.params.subscribe((params) => {
        if (params["pod"] === "pod") {
          let jobName = params["jobName"];
          let job = this.jobs.find((j) => j.name == jobName);
          this.redirectTo(job);
          this.toggleJobView(job);
        }
      });
    });
  }

  previousJobsString: string = "";
  previousQueryString: string = "";
  handleJobResponse(data: any) {
    if (data && data.length > 0) {
      const temp = this.jobs;
      this.jobs = <Job[]>JSON.parse(JSON.stringify(data));
      this.jobsCopy = <Job[]>JSON.parse(JSON.stringify(data));
      this.updateCheckboxSelectedList();
      // This is used for edit query or run query, it checks if the desired data is loaded then hide the spinner
      const currentJobsString = JSON.stringify(data);
      const currentQueryString = this.queryString;
      if (this.editQuerySpinnerFlag) {
        const isSameData = this.previousJobsString === currentJobsString;
        const isQuerySame = this.previousQueryString === currentQueryString;
        if (!isSameData || isQuerySame) {
          this.spinner.hide("jobListLoad");
          this.editQuerySpinnerFlag = false;
        }
      }
      this.previousJobsString = currentJobsString;
      this.previousQueryString = currentQueryString;

      if (this.advanceView) {
        this.advanceView.selectedJob = this.jobs.find(
          (job) => job.number === this.highlightClickedJob
        );
      }

      //~ available Apps and its versions are mapped here
      this.availableAppsWithVersions = this.jobs.reduce((acc, curr) => {
        const currApp =
          curr.application.charAt(0).toUpperCase() +
          curr.application.slice(1).toLowerCase();
        if (!acc[currApp]) {
          acc[currApp] = [];
        }

        if (
          curr.version != " " &&
          curr.version != null &&
          !acc[currApp].includes(curr.version)
        ) {
          acc[currApp].push(curr.version);
        }
        return acc;
      }, {} as ApplicationVersionDictionary);

      this.UniAppNames = Object.keys(this.availableAppsWithVersions);
      //~ end of available Apps and Version

      this.customActions = this.getCustomActionForJobListApplications(
        this.jobs
      );

      this.filterArrangeUser();

      const uniqueCores = this.jobs
        .map((job) => job.maxCores)
        .filter((value, index, self) => self.indexOf(value) === index);
      this.coresList = uniqueCores;

      this.navService.sendLastUpdate(this._headerService.getUserNewDate());

      if (!this.toShow) {
        this.arrangeJobs();
      }

      if (this.updateJobDetail) {
        this.updateJobDetails();
        this.updateJobDetail = false;
      }

      if (this.filtersApplied) {
        this.autoApplySort();
      }

      this.isJobsAvailable(null);
    } else {
      // Handle no data scenario
      this.jobs = [];
      this.isJobsAvailable(null);
    }
    this.checkIfFromPod();
  }
  // This method initiates the download of a repository from GitHub using the job service.
  //It logs the repository name and URL, then calls the service to download the repository,
  //handling the response and any potential errors with appropriate logging.
  downloadRepoFromGithub() {
    this.jobService
      .downloadRepoFromGithub(
        this.depName,
        this.currentUser,
        this.repoName,
        this.repoUrl
      )
      .subscribe({
        next: (res) => {
        },
        error: (err) => {
          console.error(err);
        },
      });
  }
  //! This function will get th custom actions based on application in the job list
  getCustomActionForJobListApplications(jobs: Job[]): CustomAction[] {
    const customActions: CustomAction[] = [];
    if (!this.apps || this.apps.length == 0) return customActions;
    const appIds: string[] = this.apps.map(a => a.appId);
    this.applicationService.getCustomActionsForJobList(this.depName, this.currentUser, appIds.join(','))
      .subscribe({
        next: (response) => {
          if (response) {
            this.customActions = JSON.parse(JSON.stringify(response));
          }
        },
        error: (err) => {
          console.error(err);
        }
      })
    return customActions;
  }

  updateJobDetails() {
    if (this.tempJobName !== this.jobs[0].name) {
      this.tempJobName = this.jobs[0].name;
      this.jobNodeName = this.jobs[0].nodelist
        ? this.jobs[0].nodelist.split(",")[0]
        : "";
      this.navService.sendChildData(this.depName);
      this.validateSyncstoreDir(
        this.jobs[0].outputDirectory,
        this.jobs[0].workDirectory
      );

      if (
        (this.jobs[0].state === JobGlobalState.Active &&
          this.jobs[0].stage === HpcJobStageNames.STAGE_JOB_EXECUTE) ||
        (this.jobs[0].state === JobGlobalState.Active &&
          this.jobs[0].stage === HpcJobStageNames.STAGE_JOB_SUBMIT)
      ) {
        this.openJobWorkstore();
      } else if (this.jobs[0].state === JobGlobalState.Active) {
        this.openJobDetails();
      } else {
        this.openJobSyncstore();
      }
    }

    this.highlightClickedJob = this.jobs[0].number;
  }

  ngOnDestroy() {
    this.dataReloadSubscription?.unsubscribe();
    this.universalSub?.unsubscribe();
    this.loadJobSub?.unsubscribe();
    this.resetSortFilter();
    this.destroy$.next();
    this.destroy$.complete();
    this.jobService.dashboardFilterApplied = null;
    this.jobService.updateJobAction(null);
  }

  ngOnChanges() {
    this.dataReloadSubscription?.unsubscribe();
    this.dataReloadSubscription = interval(
      this.syncConfig.config.jobs.listReqInterval
    ).subscribe(() => {
      // this.loadJobsData(this.entries);
      this.loadPerUserJobs$.next(this.entries);
      this.filterStatus = "All";
    });
  }

  checkForJobActions() {
    this.jobService.sendJobAction
      .pipe(
        filter((x) => x != null),
        takeUntil(this.destroy$)
      )
      .subscribe(
        (data: { jobName: string; appName: string; appVersion: string; partition: string; action: JobAction }) => {
          this.onOptionsSelected(data.jobName, data.appName, data.appVersion,data.partition, data.action);
          this.jobService.updateJobAction(null);
        }
      );
  }

  toggleStatusLists(open: boolean) {
    this.isDropdownOpen = open;
  }

  checkboxHandlers(event: Event) {
    const target = event.target as HTMLInputElement;
    const value = target.value;

    if (target.checked) {
      // Add to selected statuses if checked
      this.selectedStatuses.push(value);
    } else {
      // Remove from selected statuses if unchecked
      this.selectedStatuses = this.selectedStatuses.filter(
        (status) => status !== value
      );
    }

    // Update filter status display
    this.updateFilterStatus();
  }

  updateFilterStatus() {
    if (this.selectedStatuses.length > 0) {
      this.filterStatus = this.selectedStatuses.join(", ");
    } else {
      this.filterStatus = "All Status"; // Reset to default if nothing selected
    }
  }

  getUserRoleInText(userRole: number): string {
    switch (userRole) {
      case 0:
        return UserRoleNames.GlobalAdmin;
      case 1:
        return UserRoleNames.DeploymentAdmin;
      case 2:
        return UserRoleNames.JobOperator;
      default:
        return UserRoleNames.JobOperator;
    }
  }

  ngAfterViewInit() {
    this.elementView.GetUpdatedWidth.subscribe((x) => {
      if (x) {
        let length = x / 9;
        this.shortStringVal = length > 25 ? Math.round(length) : 25;
      } else {
        this.shortStringVal = 25;
      }
    });
  }

  getUsersForFilter() {
    this.universalSub = this.userService
      .getAllDeploymentUserForJobFilter(this.depName, this.allJobsForAllUsers)
      .subscribe({
        next: (data: any) => {
          if (!data) return;
          if (data?.users != "") {
            this.jobUsers = data?.users?.split(",");
            let idx = this.jobUsers.findIndex((x) => x == this.currentUser);
            if (idx != -1) this.jobUsers.splice(idx, 1);
            this.jobUsers = this.jobUsers.sort((a, b) => a.localeCompare(b));
          } else {
          }
        },
        error: (err) => { },
      });
  }

  getDeploymentInfo() {
    this.depService.getDeploymentInfoForJobs(this.depName).subscribe({
      next: (data: any) => {
        this.deployment = JSON.parse(JSON.stringify(data));
        this.cloudType = this.deployment.cloudType;
        this.nodeList = this.deployment?.nodes?.split(",");
        this.nodeGroupsList = this.deployment?.nodeGroups?.split(",");
      },
    });
  }

  autoApplySort() {
    if (
      this.serialNoSort ||
      this.jobSort ||
      this.coresSort ||
      this.timeCreateSort ||
      this.timeEndSort ||
      this.userSort
    ) {
      this.sortLoadData();
    } else {
      if (this.jobSort == false && this.activeSort == "jobName") {
        this.jobs = this.jobs.sort(
          (a, b) => 0 - (a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1)
        );
      }
      if (this.userSort == false && this.activeSort == "users") {
        this.jobs = this.jobs.sort(
          (a, b) => 0 - (a.user.toLowerCase() > b.user.toLowerCase() ? 1 : -1)
        );
      }
      if (this.coresSort == false && this.activeSort == "cores") {
        this.jobs = this.jobs.sort(
          (a, b) => 0 - (b.maxCores < a.maxCores ? 1 : -1)
        );
      }
    }
    if (this.filterText.length > 0) {
      this.onSearch();
    }
  }

  ///used only at initiation of the component
  arrangeJobs() {
    if (this.jobs && this.jobs.length > 0) {
      this.tempJobName = this.jobs[0].name;
      this.jobService.sendJobData(this.tempJobName);
      this.navService.sendChildData(this.depName);
      this.jobWorkDir = this.jobs[0].workDirectory;
      this.validateSyncstoreDir(
        this.jobs[0].outputDirectory,
        this.jobs[0].workDirectory
      );
      this.jobNodeName = this.jobs[0].nodelist;
      if (
        (this.jobs[0].state == JobGlobalState.Active &&
          this.jobs[0].stage == HpcJobStageNames.STAGE_JOB_EXECUTE) ||
        (this.jobs[0].state == JobGlobalState.Active &&
          this.jobs[0].stage == HpcJobStageNames.STAGE_JOB_SUBMIT)
      ) {
        this.openJobWorkstore();
      } else if (this.jobs[0].state == JobGlobalState.Active) {
        this.openJobDetails();
      } else {
        this.openJobSyncstore();
      }
      this.highlightClickedJob = this.jobs[0].number;
      this.toShow = true;
    }
  }

  redirectTo(job: Job) {
    if (this.highlightClickedJob != job.number) {
      this.highlightClickedJob = job.number;
      this.jobService.activeJob = job;
      this.jobService.sendJobData(job.name);
      this.jobService.sendSyncstoreUsed(job.assignedStorage);
    }
  }

  toggleJobView(job) {
    this.currentCustomActions = [];
    if (this.jobService.activeJob?.name == job.name && this.jobViewOpen) {
      this.jobViewOpen = false;
    } else {
      this.jobService.activeJob = job;
      this.sendCustomActionToChild(job);
      this.toShowFilter = false;
      this.jobViewOpen = true;
    }
  }

  hideJobDetails() {
    this.jobViewOpen = false;
    this.currentCustomActions = [];
  }

  // open job dialogs
  async openDialog(
    jobType: string,
    jobTemplateName?: string,
    jobName?: string,
    isResubmit?: boolean,
    isUpdatedJob?: boolean,
    event?: any
  ) {
    this.menuTrigger?.closeMenu();
    let jobsCopy = [];
    this.activeJobCores = 0;
    if (!this.deployment) {
      this.snackBar.open("Loading data, please wait...", "Ok", {
        duration: 5000,
      });
      return;
    }
    if (this.jobs) {
      jobsCopy = this.jobs?.filter(
        (job) =>
          job.state === JobGlobalState.Active && job.user === this.currentUser
      );
      jobsCopy.forEach((job) => {
        this.activeJobCores = this.activeJobCores + job["maxCores"];
      });
    }
    let Suggestions = [];
    if (isResubmit == null || isResubmit == undefined) {
      Suggestions = this.createJobNameSuggestions(jobType.toLowerCase());
      isResubmit == false;
    }
    let isDialogOpened = await this.navService.checkIfDialogIsAlreadyOpen(
      jobType
    );
    if (isDialogOpened) return;
    if (!this.dialog.getDialogById("jobOutputDialogJobs")) {
      this.navService.closeOpenedDialogs();
    }
    if (this.cloudType == CloudTypes.MicrosoftAzure) {
      if (!this.storageDataTransferService.shareClient) {
        this.storageService
          .getStorageSasShare(this.depName, "default")
          .subscribe({
            next: (data: any) => {
              this.storageDataTransferService
                .azureFilesInitialize(data?.sas, data?.share)
                .then((data) => { });
            },
            error: (err) => { },
          });
      }
    }
    let tags = await lastValueFrom(this.userService.getUserTags());
    let appDialogData = {
      cloudType: this.cloudType,
      depName: this.depName,
      appName: jobType,
      nodeName: this.jobNodeName,
      jobName: jobName,
      isResubmit: isResubmit,
      suggestions: Suggestions,
      headNodeIp: this.fileUploadHeadNodeIP,
      alreadyAllocatedCores: this.activeJobCores,
      copyJobDataToSyncstore: this.deployment.copyJobDataToSyncstore,
      keepJobDataInWorkstore: this.deployment.keepJobDataInWorkstore,
      isJobUpdatedFlag: isUpdatedJob,
      templateName: jobTemplateName,
      routeViaSynchpc: this.deployment.routeViaSynchpc,
      tags: tags,
    };
    if (jobType === JobTypes.Abaqus) {
      const dialogRef = this.dialog.open(AbaqusJobComponent, {
        width: "70%",
        autoFocus: true,
        disableClose: true,
        hasBackdrop: false,
        data: appDialogData,
        panelClass: "job-dialog-containers",
        id: "addNewJobDialogAbaqus",
      });
      dialogRef.afterClosed().subscribe((res) => {
        this.reloadJobListAfterDialogClosed(res);
        event.target.options.selectedIndex = 0; // To reset the value of select
      });
    } else if (jobType === JobTypes.Starccm) {
      const dialogRef = this.dialog.open(StarccmJobComponent, {
        width: "70%",
        autoFocus: true,
        disableClose: true,
        hasBackdrop: false,
        data: appDialogData,
        panelClass: "job-dialog-containers",
        id: "addNewJobDialogStarccm",
      });
      dialogRef.afterClosed().subscribe((res) => {
        this.reloadJobListAfterDialogClosed(res);
        event.target.options.selectedIndex = 0; // To reset the value of select
      });
    } else if (jobType === JobTypes.Cfx) {
      const dialogRef = this.dialog.open(CfxJobComponent, {
        width: "70%",
        autoFocus: true,
        disableClose: true,
        hasBackdrop: false,
        data: appDialogData,
        panelClass: "job-dialog-containers",
        id: "addNewJobDialogCfx",
      });
      dialogRef.afterClosed().subscribe((res) => {
        this.reloadJobListAfterDialogClosed(res);
        event.target.options.selectedIndex = 0; // To reset the value of select
      });
    } else if (jobType === JobTypes.Fluent) {
      const dialogRef = this.dialog.open(FluentJobComponent, {
        width: "70%",
        autoFocus: true,
        disableClose: true,
        hasBackdrop: false,
        data: appDialogData,
        panelClass: "job-dialog-containers",
        id: "addNewJobDialogFluent",
      });
      dialogRef.afterClosed().subscribe((res) => {
        this.reloadJobListAfterDialogClosed(res);
        event.target.options.selectedIndex = 0; // To reset the value of select
      });
    } else if (jobType === JobTypes.Mechanical) {
      const dialogRef = this.dialog.open(MechanicalJobComponent, {
        width: "70%",
        autoFocus: true,
        disableClose: true,
        hasBackdrop: false,
        data: appDialogData,
        panelClass: "job-dialog-containers",
        id: "addNewJobDialogMech",
      });
      dialogRef.afterClosed().subscribe((res) => {
        this.reloadJobListAfterDialogClosed(res);
        event.target.options.selectedIndex = 0; // To reset the value of select
      });
    } else if (jobType === JobTypes.Lsdyna) {
      const dialogRef = this.dialog.open(LsDynaJobComponent, {
        width: "70%",
        autoFocus: true,
        disableClose: true,
        hasBackdrop: false,
        data: appDialogData,
        panelClass: "job-dialog-containers",
        id: "addNewJobDialogLsdyna",
      });
      dialogRef.afterClosed().subscribe((res) => {
        this.reloadJobListAfterDialogClosed(res);
        event.target.options.selectedIndex = 0; // To reset the value of select
      });
    } else if (jobType === JobTypes.Converge) {
      const dialogRef = this.dialog.open(ConvergeJobComponent, {
        width: "70%",
        autoFocus: true,
        disableClose: true,
        hasBackdrop: false,
        data: appDialogData,
        panelClass: "job-dialog-containers",
        id: "addNewJobDialogConverge",
      });
      dialogRef.afterClosed().subscribe((res) => {
        this.reloadJobListAfterDialogClosed(res);
        event.target.options.selectedIndex = 0; // To reset the value of select
      });
    } else if (jobType === JobTypes.Actran) {
      const dialogRef = this.dialog.open(MscActranComponent, {
        width: "70%",
        autoFocus: true,
        disableClose: true,
        hasBackdrop: false,
        data: appDialogData,
        panelClass: "job-dialog-containers",
        id: "addNewJobDialogActran",
      });
      dialogRef.afterClosed().subscribe((res) => {
        this.reloadJobListAfterDialogClosed(res);
        event.target.options.selectedIndex = 0; // To reset the value of select
      });
    } else if (jobType === JobTypes.Nastran) {
      const dialogRef = this.dialog.open(MscNastranJobComponent, {
        width: "70%",
        autoFocus: true,
        disableClose: true,
        hasBackdrop: false,
        data: appDialogData,
        panelClass: "job-dialog-containers",
        id: "addNewJobDialogNastran",
      });
      dialogRef.afterClosed().subscribe((res) => {
        this.reloadJobListAfterDialogClosed(res);
        event.target.options.selectedIndex = 0; // To reset the value of select
      });
    } else if (jobType === JobTypes.Optistruct) {
      const dialogRef = this.dialog.open(OptistructComponent, {
        width: "70%",
        autoFocus: true,
        disableClose: true,
        hasBackdrop: false,
        data: appDialogData,
        panelClass: "job-dialog-containers",
        id: "addNewJobDialogOptistruct",
      });
      dialogRef.afterClosed().subscribe((res) => {
        this.reloadJobListAfterDialogClosed(res);
        event.target.options.selectedIndex = 0; // To reset the value of select
      });
    } else if (jobType === JobTypes.Optis) {
      const dialogRef = this.dialog.open(OptisComponent, {
        width: "70%",
        autoFocus: true,
        disableClose: true,
        hasBackdrop: false,
        data: appDialogData,
        panelClass: "job-dialog-containers",
        id: "addNewJobDialogOptis",
      });
      dialogRef.afterClosed().subscribe((res) => {
        this.reloadJobListAfterDialogClosed(res);
        event.target.options.selectedIndex = 0; // To reset the value of select
      });
    } else if (jobType === JobTypes.Radioss) {
      const dialogRef = this.dialog.open(RadiossComponent, {
        width: "70%",
        autoFocus: true,
        disableClose: true,
        hasBackdrop: false,
        data: appDialogData,
        panelClass: "job-dialog-containers",
        id: "addNewJobDialogRadioss",
      });
      dialogRef.afterClosed().subscribe((res) => {
        this.reloadJobListAfterDialogClosed(res);
        event.target.options.selectedIndex = 0; // To reset the value of select
      });
    } else if (jobType === JobTypes.Hfss) {
      const dialogRef = this.dialog.open(HfssComponent, {
        width: "70%",
        autoFocus: true,
        disableClose: true,
        hasBackdrop: false,
        data: appDialogData,
        panelClass: "job-dialog-containers",
        id: "addNewJobDialogHfss",
      });
      dialogRef.afterClosed().subscribe((res) => {
        this.reloadJobListAfterDialogClosed(res);
        event.target.options.selectedIndex = 0; // To reset the value of select
      });
    } else if (jobType === JobTypes.Fluidx) {
      const dialogRef = this.dialog.open(NanoFluidXComponent, {
        width: "70%",
        autoFocus: true,
        disableClose: true,
        hasBackdrop: false,
        data: appDialogData,
        panelClass: "job-dialog-containers",
        id: "addNewJobDialogFluidx",
      });
      dialogRef.afterClosed().subscribe((res) => {
        this.reloadJobListAfterDialogClosed(res);
        event.target.options.selectedIndex = 0; // To reset the value of select
      });
    } else if (jobType === JobTypes.Command || jobType === JobTypes.OpenFoam) {
      const dialogRef = this.dialog.open(CommandJobComponent, {
        width: "70%",
        autoFocus: true,
        disableClose: true,
        hasBackdrop: false,
        data: appDialogData,
        panelClass: "job-dialog-containers",
        id: "addNewJobDialogCommand",
      });
      dialogRef.afterClosed().subscribe((res) => {
        this.reloadJobListAfterDialogClosed(res);
        event.target.options.selectedIndex = 0; // To reset the value of select
      });
    } else if (jobType === JobTypes.AIML) {
      const dialogRef = this.dialog.open(AimlJobComponent, {
        width: "70%",
        autoFocus: false,
        disableClose: true,
        hasBackdrop: false,
        data: appDialogData,
        panelClass: "job-dialog-containers",
        id: "addNewJobDialogCommand",
      });
      dialogRef.afterClosed().subscribe((res) => {
        this.reloadJobListAfterDialogClosed(res);
      });
    } else {
      const dialogRef = this.dialog.open(DynamicJobComponent, {
        width: "70%",
        autoFocus: true,
        disableClose: true,
        hasBackdrop: false,
        data: appDialogData,
        panelClass: "job-dialog-containers",
        id: "addNewJobDialogDynamic",
      });
      dialogRef.afterClosed().subscribe((res) => {
        this.reloadJobListAfterDialogClosed(res);
        event.target.options.selectedIndex = 0; // To reset the value of select
      });
    }
  }

  reloadJobListAfterDialogClosed(result, flag?: boolean) {
    this.jobService.updateJobAction(null);
    if (result == true) {
      this.loadJobSub?.unsubscribe();
      setTimeout(() => {
        if (!flag) {
          this.updateJobDetail = true;
        } else {
          this.jobService.sendJobData(this.tempJobName);
        }
        // this.loadJobsData(this.jobs?.length > 0 ? this.entries : 1);
        this.loadPerUserJobs$.next(this.jobs?.length > 0 ? this.entries : 1);
      }, 500);
      this.hideJobDetails();

      // This is for rare scenario when user tries to submit his first job
      if (this.jobs.length == 0) {
        setTimeout(() => {
          this.refreshComponent();
        }, 5000);
      }
    }
  }

  openJobDetails() {
    this.jobService.sendActiveTab(1);
    this.jobService.sendJobData(this.tempJobName);
    this.router.navigate([this.tempJobName, "jobDetails"], {
      relativeTo: this.route,
    });
    this.syncStoreUsage = null;
    this.workStoreUsage = null;
  }

  openJobSyncstore() {
    this.jobService.sendActiveTab(2);
    this.jobService.sendJobNode(this.jobNodeName);
    if (!this.jobSyncDir) {
      this.jobSyncDir = this.jobService.getJobDirectoryPaths?.syncStorePath;
    }
    if (this.jobSyncDir) {
      this.jobSyncDir = this.jobSyncDir.replace("D:", "/mnt/syncstore");
      this.jobSyncDir = this.jobSyncDir.replace(/\\/g, "/");

      this.storageService.sendJobStorageDirectoryPath(this.jobSyncDir);
      this.router.navigate(
        [this.tempJobName, "storage", this.currentStorageName],
        { relativeTo: this.route }
      );
      this.toShow = true;
      this.workStoreUsage = null;
    }
  }

  validateSyncstoreDir(outputDir, workDir) {
    if (outputDir == "Data back up option not selected") {
      this.jobSyncDir = `${this.env.envVariables.syncStoreRoute}/${this.authenticationService.currentUserValue.username}`;
    } else {
      this.jobSyncDir = outputDir;
    }
    this.jobWorkDir = workDir;
  }

  openJobWorkstore() {
    this.jobService.sendActiveTab(3);
    let currJob = this.jobs.find((job) => job.name === this.tempJobName);
    this.jobService.activeJob = currJob;
    this.jobNodeName = currJob?.nodelist?.split(",")[0];
    this.jobService.sendJobNode(this.jobNodeName);
    if (!currJob?.isLocalStore) {
      this.jobService.sendJobNode("");
    }
    if (!this.jobWorkDir) {
      this.jobWorkDir = this.jobService.getJobDirectoryPaths.workStorePath;
    }
    this.storageService.sendJobStorageDirectoryPath(this.jobWorkDir);
    this.router.navigate(
      [this.tempJobName, "storage", this.currentStorageName],
      { relativeTo: this.route }
    );
    this.toShow = true;
    this.syncStoreUsage = null;
  }

  async onOptionsSelected(jobName: string, appName,appVersion, partition,event) {
    let actionText, actionValue;
    let job: Job = this.jobs.find((jb) => jb.name == jobName);
    if (event.target) {
      event.stopPropagation();
      actionText =
        event.target.options[event.target.options.selectedIndex].text;
      actionValue =
        event.target.options[event.target.options.selectedIndex].value;
      const element: any = document.getElementById(job.number.toString());
      element.value = -1;
    } else {
      actionText = event.actionName;
      actionValue = event.actionValue;
    }
    if (
      this.dialog.getDialogById("jobOutputDialogJobs") &&
      actionValue == "3"
    ) {
      event.target.options.selectedIndex = 0; // To reset the value of select
    }
    if (this.dialog.getDialogById("jobOutputDialogJobs")) {
      this.snackBar.open(
        "Please close the already opened/minimized output dialog",
        "Ok",
        {
          duration: 5000,
        }
      );
      return;
    }
    if (actionValue == "3") {
      let currJob: Job = this.jobs.find((jb) => jb.name == jobName);
      this.dialog
        .open(JobOutputDialogComponent, {
          width: "90%",
          autoFocus: false,
          disableClose: true,
          hasBackdrop: false,
          id: "jobOutputDialogJobs",
          data: {
            depName: this.depName,
            jobName: jobName,
            path:
              currJob.state == HpcVMStates.STATE_CODE_STARTED
                ? currJob.workDirectory + "/" + currJob.outputFile
                : currJob.outputDirectory +
                "/" +
                currJob.outputFile +
                "/" +
                currJob.outputFile,
            id: "jobOutputDialogJobs",
            state: currJob.state,
          },
          panelClass: "custom-output-dialog-container",
        })
        .afterClosed()
        .subscribe(() => {
          event.target.options.selectedIndex = 0; // To reset the value of select
        });
    } else if (actionValue == "4") {
      this.dialog
        .open(JobChartDialogComponent, {
          width: "90%",
          autoFocus: false,
          disableClose: true,
          hasBackdrop: false,
          id: "jobChartDialog",
          data: {
            depName: this.depName,
            jobName: jobName,
            path: "",
            id: "jobChartDialog",
          },
          panelClass: "custom-output-dialog-container",
        })
        .afterClosed()
        .subscribe(() => {
          event.target.options.selectedIndex = 0; // To reset the value of select
        });
    } else if (actionValue == "-1") {
      this.snackBar.open("Please select an action", "Ok", { duration: 5000 });
      // const dialogRef = this.dialog.open(JobConfirmationDialogComponent, {
      //   width: "35%",
      //   autoFocus: true,
      //   disableClose: true,
      //   data: {
      //     depName: this.depName,
      //     jobName: jobName,
      //     actionText: actionText,
      //     actionValue: parseInt(actionValue),
      //     title: "No",
      //     message: "Please select an action!",
      //     noBtnText: "Ok",
      //     yesBtnText: "Close",
      //   },
      // });
      // dialogRef.afterClosed().subscribe((res) => {
      //   this.reloadJobListAfterDialogClosed(res);
      // });
    } else if (actionValue == "0") {
      const dialogRef = this.dialog.open(JobConfirmationDialogComponent, {
        width: "35%",
        autoFocus: true,
        disableClose: true,
        data: {
          depName: this.depName,
          jobName: jobName,
          actionText: actionText,
          actionValue: parseInt(actionValue),
          title: "Cancel Job",
          message: "Do you want to ",
          noBtnText: "No",
          yesBtnText: "Yes",
        },
      });
      dialogRef.afterClosed().subscribe((res) => {
        this.reloadJobListAfterDialogClosed(res, true);
        event.target.options.selectedIndex = 0; // To reset the value of select
      });
    } else if (actionValue == "20") {
      this.dialog
        .open(JobPriorityDialogComponent, {
          width: "25%",
          autoFocus: true,
          disableClose: true,
          data: {
            depName: this.depName,
            jobName: jobName,
            actionText: actionText,
            actionValue: parseInt(actionValue),
            currPriority: job.priority,
          },
        })
        .afterClosed()
        .subscribe((res) => {
          this.reloadJobListAfterDialogClosed(res, true);
          event.target.options.selectedIndex = 0; // To reset the value of select
        });
    } else if (actionValue == "21") {
      this.dialog
        .open(RunJobCommandComponent, {
          width: "40%",
          autoFocus: true,
          disableClose: true,
          id: "runJobCommandDialog",
          data: {
            depName: this.depName,
            jobName: jobName,
            actionText: actionText,
            actionValue: parseInt(actionValue),
            runCommandFromJobActions: true,
            id: "runJobCommandDialog",
          },
          panelClass: "run-command-dialog",
        })
        .afterClosed()
        .subscribe(() => {
          event.target.options.selectedIndex = 0; // To reset the value of select
        });
    } else if (actionValue == "8") {
      this.openDialog(appName, "", jobName, true, false, event);
    } else if (actionValue == "27") {
      this.openDialog(appName, "", jobName, true, true, event);
    } else if (actionValue == "5") {
      const dialogRef = this.dialog.open(JobConfirmationDialogComponent, {
        width: "35%",
        autoFocus: true,
        disableClose: true,
        data: {
          depName: this.depName,
          jobName: jobName,
          actionText: actionText,
          actionValue: parseInt(actionValue),
          title: actionText,
          message: "Do you want to ",
          noBtnText: "No",
          yesBtnText: "Yes",
        },
      });
      dialogRef.afterClosed().subscribe((res) => {
        this.reloadJobListAfterDialogClosed(res, true);
        if (res) {
          this.snackBar.open("Auto Download Enabled", "Ok", { duration: 5000 });
        }
        event.target.options.selectedIndex = 0; // To reset the value of select
      });
    } else if (actionValue == "6") {
      const dialogRef = this.dialog.open(JobConfirmationDialogComponent, {
        width: "35%",
        autoFocus: true,
        disableClose: true,
        data: {
          depName: this.depName,
          jobName: jobName,
          actionText: actionText,
          actionValue: parseInt(actionValue),
          title: actionText,
          message: "Do you want to ",
          noBtnText: "No",
          yesBtnText: "Yes",
        },
      });
      dialogRef.afterClosed().subscribe((res) => {
        this.reloadJobListAfterDialogClosed(res, true);
        if (res) {
          this.snackBar.open("Auto Download Cancelled", "Ok", {
            duration: 5000,
          });
        }
        event.target.options.selectedIndex = 0; // To reset the value of select
      });
    } else if (actionValue == "7") {
      const dialogRef = this.dialog.open(JobConfirmationDialogComponent, {
        width: "35%",
        autoFocus: true,
        disableClose: true,
        data: {
          depName: this.depName,
          jobName: jobName,
          actionText: actionText,
          actionValue: parseInt(actionValue),
          title: actionText,
          message: "Do you want to ",
          noBtnText: "No",
          yesBtnText: "Yes",
        },
      });
      dialogRef.afterClosed().subscribe((res) => {
        this.reloadJobListAfterDialogClosed(res, true);
        if (res) {
          this.snackBar.open("Auto Download Re-Enabled", "Ok", {
            duration: 5000,
          });
        }
        event.target.options.selectedIndex = 0; // To reset the value of select
      });
    } else if (actionValue == "9" || actionValue == "10") {
      const dialogRef = this.dialog.open(JobConfirmationDialogComponent, {
        width: "35%",
        autoFocus: true,
        disableClose: true,
        data: {
          depName: this.depName,
          jobName: jobName,
          actionText: actionText,
          actionValue: parseInt(actionValue),
          title: actionText,
          message: "Do you want to ",
          noBtnText: "No",
          yesBtnText: "Yes",
        },
      });
      dialogRef.afterClosed().subscribe((res) => {
        if (res) {
          let autoShutFlag: boolean;
          if (actionValue == "10") {
            autoShutFlag = false;
          } else {
            autoShutFlag = true;
          }

          this.jobService
            .triggerAnActionForJob(
              this.depName,
              jobName,
              actionText,
              parseInt(actionValue),
              String(autoShutFlag),
              "",
              ""
            )
            .subscribe(() => {
              this.reloadJobListAfterDialogClosed(res, true);
            });
        }
        event.target.options.selectedIndex = 0; // To reset the value of select
      });
    } else if (actionValue == "12" || actionValue == "13") {
      const dialogRef = this.dialog.open(JobConfirmationDialogComponent, {
        width: "35%",
        autoFocus: true,
        disableClose: true,
        data: {
          depName: this.depName,
          jobName: jobName,
          actionText: actionText,
          actionValue: parseInt(actionValue),
          title: actionText,
          message: "Do you want to ",
          noBtnText: "No",
          yesBtnText: "Yes",
        },
      });
      dialogRef.afterClosed().subscribe((res) => {
        if (res) {
          let stopAllocated: boolean;
          if (actionValue == "13") {
            stopAllocated = false;
          } else {
            stopAllocated = true;
          }

          this.jobService
            .triggerAnActionForJob(
              this.depName,
              jobName,
              actionText,
              parseInt(actionValue),
              String(stopAllocated),
              "",
              ""
            )
            .subscribe(() => {
              this.reloadJobListAfterDialogClosed(res, true);
            });
        }
        event.target.options.selectedIndex = 0; // To reset the value of select
      });
    } else if (actionValue?.length > 3) {
      let currentCustomActionToPerform: CustomAction = this.customActions.find(
        (e) => e.id == actionValue
      );
      this.dialog
        .open(ConfirmDialogComponent, {
          width: "35%",
          autoFocus: true,
          disableClose: true,
          data: {
            titleMessage: "Confirm Action",
            bodyMessage:
              "Scripts - " +
              currentCustomActionToPerform.script +
              " will run.<br>Are you sure you want to perform the action: '" +
              currentCustomActionToPerform.actionName +
              "'?",
            submitText: "Yes",
            cancelText: "No",
          },
        })
        .afterClosed()
        .subscribe({
          next: (res) => {
            if (res) {
              this.jobService
                .triggerAnActionForJob(
                  this.depName,
                  jobName,
                  actionText,
                  33, // In api of /TriggerJobAction JobActions.ValCustomAction = 33
                  "true",
                  "",
                  "",
                  JSON.stringify(currentCustomActionToPerform)
                )
                .subscribe({
                  next: (res) => {
                    this.snackBar.open("Custom Action Run", "OK", {
                      duration: 5000,
                    });
                  },
                  error: (err) => {
                    this.snackBar.open("Custom Action Failed to Run", "Close", {
                      duration: 5000,
                    });
                  },
                });
            }
          },
          error: (err) => {
            console.error(err);
          },
        });
    }
    else if (actionValue == "33") {
      if (!job?.podNames) {
        this.snackBar.open("No Pod Found", "Ok", { duration: 5000 });
        return;
      }
      if (job?.podNames.toLowerCase() == "na") {
        this.snackBar.open("No Pod Found", "Ok", { duration: 5000 });
        return;
      }
      const headNodeIp: any = await lastValueFrom(
        this.storageService.getHeadNodeIp(this.depName)
      );

      fetch('https://' + headNodeIp.vmIp + ':' + this.env.envVariables.UtilityAccessPort + "/health", { mode: 'no-cors' })
        .then(() => {
          this.navService.closeOpenedDialogs();
          this.dialog.open(TerminalComponent, {
            autoFocus: false,
            disableClose: true,
            panelClass: "custom-terminal-container",
            hasBackdrop: false,
            id: "terminalDialog",
            data: {
              username: '',
              password: '',
              serverAddress: this.deploymentService.getUrlForUtilityService(
                this.depName,
                headNodeIp.vmIp,
                '5001',
                4,
                true
              ),
              reqFromPod: true,
              namespace: 'default',
              podName: job?.podNames?.split(',')[0],
              headNodeIp: headNodeIp.vmIp,
            },
          });
        })
        .catch((err) => {
          this.snackBar.open("Please check and accept pod manager status", "OK", {}).afterDismissed().subscribe(() => {
            window.open('https://' + headNodeIp.vmIp + ':' + this.env.envVariables.UtilityAccessPort + "/health", '_blank');
          });
          return;
        });


    }
    else if (actionValue == "34") {
      console.log(partition)
      this.dialog
        .open(JobPartitionDialogComponent, {
          width: "25%",
          autoFocus: true,
          disableClose: true,
          data: {
            depName: this.depName,
            partition: partition,
            jobName: jobName,
            appName: appName,
            appVersion: appVersion,
            actionText: actionText,
            actionValue: parseInt(actionValue),
          },
        })
        .afterClosed()
        .subscribe((res) => {
          this.reloadJobListAfterDialogClosed(res, true);
          event.target.options.selectedIndex = 0; // To reset the value of select
        });

    }
    else {
      if (this.dialog.getDialogById("jobActionConfirmDialog")) {
        this.dialog.getDialogById(
          "jobActionConfirmDialog"
        ).componentInstance.toogleDialog = false;
        return;
      }
      const dialogRef = this.dialog.open(JobConfirmationDialogComponent, {
        width: "35%",
        autoFocus: false,
        disableClose: true,
        hasBackdrop: false,
        id: "jobActionConfirmDialog",
        data: {
          depName: this.depName,
          jobName: jobName,
          actionText: actionText,
          actionValue: parseInt(actionValue),
          title: actionText,
          message: "Do you want to ",
          noBtnText: "Cancel",
          yesBtnText: "Ok",
        },
      });
      dialogRef.afterClosed().subscribe((res) => {
        this.reloadJobListAfterDialogClosed(res);
        event.target.options.selectedIndex = 0; // To reset the value of select
      });
    }
  }

  getJobActionsForThisJob(thisJob: Job): JobAction[] {
    let jobActions: JobAction[] = [
      {
        actionName: JobActionsText.TxtActions,
        actionValue: JobActionsValue.ValActions,
      },
    ];

    if (this.isMonitor) {
      return jobActions;
    }

    if (thisJob) {
      let username = this.authenticationService.currentUserValue.username;
      let role = this.authenticationService.getRole();
      if (
        username == thisJob.user ||
        (role == UserRoleNames.GlobalAdmin && this.allowAdminJobActionsToUsers)
      ) {
        if (
          thisJob.state == JobGlobalState.Active &&
          thisJob.status != OperationStatus.Cancelled &&
          thisJob.status != OperationStatus.Cancelling &&
          thisJob.status != OperationStatus.ContactSupport &&
          thisJob.status != OperationStatus.Wait
        ) {
          jobActions.push(
            new JobAction(JobActionsText.TxtCancel, JobActionsValue.ValCancel)
          );
          jobActions.push(
            new JobAction(
              JobActionsText.TxtRunCommand,
              JobActionsValue.ValRunCommand
            )
          );
          if (thisJob.status.includes(OperationStatus.Queued)) {
            if (thisJob.isHeld) {
              jobActions.push(
                new JobAction(
                  JobActionsText.TxtReleaseJob,
                  JobActionsValue.ValReleaseJob
                )
              );
            } else {
              jobActions.push(
                new JobAction(
                  JobActionsText.TxtHoldJob,
                  JobActionsValue.ValHoldJob
                )
              );
            }
          }

          if (
            thisJob.stage != HpcJobStageNames.STAGE_JOB_EXECUTE ||
            thisJob.status != OperationStatus.Running
          ) {
            jobActions.push(
              new JobAction(
                JobActionsText.TxtChangeJobPriority,
                JobActionsValue.ValChangeJobPriority
              )
            );
            jobActions.push(
              new JobAction(
                JobActionsText.TxtChangeJobPartition,
                JobActionsValue.ValChangeJobPartition
              )
            );
          }

          if (this.cloudType == CloudTypes.MicrosoftAzure) {
            if (!this.autoRescaleFlag) {
              this.autoRescaleFlag =
                this.deploymentService.getRescaleFlagOfDeployment(this.depName);
            }
            if (
              this.autoRescaleFlag === false &&
              (role == UserRoleNames.GlobalAdmin ||
                role == UserRoleNames.DeploymentAdmin)
            ) {
              if (
                thisJob.autoShut &&
                thisJob.autoShut.toLowerCase() == "true"
              ) {
                jobActions.push(
                  new JobAction(
                    JobActionsText.TxtDisableAutoShut,
                    JobActionsValue.ValDisableAutoShut
                  )
                );
              } else {
                jobActions.push(
                  new JobAction(
                    JobActionsText.TxtEnableAutoShut,
                    JobActionsValue.ValEnableAutoShut
                  )
                );
              }
            }
          }

          if (
            this.cloudType != CloudTypes.OnPremise &&
            (role == UserRoleNames.GlobalAdmin ||
              role == UserRoleNames.DeploymentAdmin) &&
            this.autoRescaleFlag === false
          ) {
            if (
              thisJob.stopAllocated &&
              thisJob.stopAllocated.toLowerCase() == "true"
            ) {
              jobActions.push(
                new JobAction(
                  JobActionsText.TxtDisableStopAllocatedNodes,
                  JobActionsValue.ValDisableStopAllocatedNodes
                )
              );
            } else {
              jobActions.push(
                new JobAction(
                  JobActionsText.TxtStopAllocatedNodes,
                  JobActionsValue.ValStopAllocatedNodes
                )
              );
            }
          }
        }

        if (thisJob.status == OperationStatus.Wait) {
          jobActions.push(
            new JobAction(JobActionsText.TxtCancel, JobActionsValue.ValCancel)
          );
        }

        if (
          thisJob.state == "Inactive" &&
          thisJob.stage == HpcJobStageNames.STAGE_JOB_EXECUTE &&
          thisJob.status != OperationStatus.Cancelling
        ) {
          jobActions.push(
            new JobAction(
              JobActionsText.TxtResubmit,
              JobActionsValue.ValResubmit
            )
          );
          jobActions.push(
            new JobAction(
              JobActionsText.TxtDataDelete,
              JobActionsValue.ValDataDelete
            )
          );
        }
        if (
          thisJob.state != "Delete" &&
          thisJob.state != HpcVMStates.STATE_CODE_STARTED &&
          thisJob.status != OperationStatus.Cancelling
        ) {
          jobActions.push(
            new JobAction(JobActionsText.TxtDelete, JobActionsValue.ValDelete)
          );
        }

        if (
          ["Cancelled", "Cancelling"].includes(thisJob.status) &&
          thisJob.state != "Inactive" &&
          (role == UserRoleNames.GlobalAdmin || thisJob.user == this.authenticationService.currentUserValue.username)
        ) {
          jobActions.push(
            new JobAction(
              JobActionsText.TxtInactiveJob,
              JobActionsValue.ValInactiveJob
            )
          );
        }

        try{
          if (
            thisJob.stage == HpcJobStageNames.STAGE_JOB_EXECUTE &&
            thisJob.application != JobTypes.Command
          ) {
            let app: any = this.apps && this.apps?.length > 0 ? this.apps.filter(x => x.appName?.toLowerCase() == thisJob.application?.toLowerCase()
              && x.appVersionText?.toLowerCase() == thisJob.version?.toLowerCase())[0] : null;
            if (app && app != null) {
              if (thisJob.isSuspended) {
                jobActions.push(
                  new JobAction(
                    JobActionsText.TxtResumeJob,
                    JobActionsValue.ValResumeJob
                  )
                );
              } else if (app?.suspendFile != null && app?.suspendFile != '') {
                jobActions.push(
                  new JobAction(
                    JobActionsText.TxtSuspendJob,
                    JobActionsValue.ValSuspendJob
                  )
                );
              }
            }
          }
        }
        catch{
          // do nothing
        }

        if (
          thisJob.stage != HpcJobStageNames.STAGE_JOB_INIT &&
          thisJob.status != OperationStatus.Cancelled
        ) {
          if (
            thisJob.stage == HpcJobStageNames.STAGE_JOB_EXECUTE &&
            (thisJob.status == OperationStatus.Succeeded ||
              thisJob.status == OperationStatus.Failed) &&
            thisJob.downloadState == OutputDownloadStatus.Disabled
          ) {
            jobActions.push(
              new JobAction(
                JobActionsText.TxtEnableDownload,
                JobActionsValue.ValEnableDownload
              )
            );
          }

          if (
            thisJob.downloadState &&
            [
              OutputDownloadStatus.Completed,
              OutputDownloadStatus.Failed,
              OutputDownloadStatus.Cancelled,
              OutputDownloadStatus.Unknown,
              "Unknown",
            ].includes(thisJob.downloadState)
          ) {
            jobActions.push(
              new JobAction(
                JobActionsText.TxtReEnableDownload,
                JobActionsValue.ValReEnableDownload
              )
            );
          }

          if (
            (thisJob.downloadState &&
              thisJob.downloadState == OutputDownloadStatus.Enabled) ||
            thisJob.downloadState == OutputDownloadStatus.InProgress
          ) {
            jobActions.push(
              new JobAction(
                JobActionsText.TxtCancelDownload,
                JobActionsValue.ValCancelDownload
              )
            );
          }
        }
      }

      if (
        thisJob.stage == HpcJobStageNames.STAGE_JOB_EXECUTE &&
        !thisJob.status.includes(OperationStatus.Queued)
      ) {
        jobActions.push(
          new JobAction(JobActionsText.TxtOutput, JobActionsValue.ValOutput)
        );
        if (thisJob?.isPlottable) {
          jobActions.push(
            new JobAction(JobActionsText.TxtGraph, JobActionsValue.ValGraph)
          );
        }
      }

      if (
        thisJob.stage == HpcJobStageNames.STAGE_JOB_EXECUTE &&
        thisJob.status == OperationStatus.Wait
      ) {
        jobActions.push(
          new JobAction(JobActionsText.TxtCancel, JobActionsValue.ValCancel)
        );
      }

      if (thisJob.stage == HpcJobStageNames.STAGE_JOB_EXECUTE && thisJob.status == OperationStatus.Running && thisJob.application == JobTypes.AIML) {
        jobActions.push(
          new JobAction(JobActionsText.TxtConnectToPod, JobActionsValue.ValConnectToPod)
        );
      }

      if (this.checkIfCustomActionIsAllowed(thisJob)) {
        //! This is to add the custom actions for the job
        let appId = this.apps?.find(a => thisJob.application === a.appName && thisJob.version === a.appVersionText)?.appId;
        if (appId) {
          this.customActions?.filter(c => c.appId === appId).forEach(c => {
            if (thisJob.stage == "Job Execute") {
              if (c.state.includes(thisJob.state)) {
                if (c.status.includes(thisJob.status.split(" ")[0])) {
                  jobActions?.push(new JobAction(c.actionName, c.id));
                }
              }
            }
          });
        }
      }
    }
    return jobActions;
  }

  checkIfCustomActionIsAllowed(thisJob: Job) {
    let currentCloudType: string = this._headerService.getCloudNameForDeployment(this.depName);
    return currentCloudType === CloudTypes.OnPremise ? true : (thisJob.state !== JobGlobalState.Inactive);
  }

  sendCustomActionToChild(thisJob) {
    if (this.checkIfCustomActionIsAllowed(thisJob)) {
      let appId = this.apps?.find(a => thisJob.application === a.appName && thisJob.version === a.appVersionText)?.appId;
      if (appId) {
        this.customActions?.filter(c => c.appId === appId).forEach(c => {
          if (thisJob.stage == "Job Execute") {
            if (c.state.includes(thisJob.state)) {
              if (c.status.includes(thisJob.status.split(" ")[0])) {
                this.currentCustomActions.push(new JobAction(c.actionName, c.id));
              }
            }
          }
        });
      }
    }
  }

  download(filename, fileData) {
    filename = filename.replace(/['"]+/g, "");
    let url = window.URL.createObjectURL(fileData);
    let elementAnchor = document.createElement("a");
    document.body.appendChild(elementAnchor);
    elementAnchor.setAttribute("style", "display: none");
    elementAnchor.href = url;
    elementAnchor.download = filename;
    elementAnchor.click();
    window.URL.revokeObjectURL(url);
    elementAnchor.remove();
  }

  formatDate(dateString: string) {
    const date = new Date(dateString);
    let formattedDate = `${String(date.getDate()).padStart(2, "0")}-${String(
      date.getMonth() + 1
    ).padStart(2, "0")}-${date.getFullYear().toString().slice(2)}`;
    return new Date("20" + formattedDate.split("-").reverse().join("-"));
  }

  loadJobsData(entries: number) {
    let test = [];
    if (entries == 0) entries = 1;
    this.loadJobSub = this.jobService
      .getJobPerUser(
        this.depName,
        this.filterUser,
        entries,
        this.allJobsForAllUsers,
        this.isQueryActive,
        this.queryString
      )
      .subscribe({
        next: (data) => {
          if (data) {
            this.jobs = <Job[]>JSON.parse(JSON.stringify(data));
            this.jobsCopy = <Job[]>JSON.parse(JSON.stringify(data));
            this.filterArrangeUser();
            this.jobs.forEach((job) => {
              if (!test.includes(job.maxCores)) {
                test.push(job.maxCores);
              }
            });

            //~ available Apps and its versions are mapped here
            this.availableAppsWithVersions = this.jobs.reduce((acc, curr) => {
              const currApp =
                curr.application.charAt(0).toUpperCase() +
                curr.application.slice(1).toLowerCase();
              if (!acc[currApp]) {
                acc[currApp] = [];
              }

              if (
                curr.version != " " &&
                curr.version != null &&
                !acc[currApp].includes(curr.version)
              ) {
                acc[currApp].push(curr.version);
              }
              return acc;
            }, {} as ApplicationVersionDictionary);

            this.UniAppNames = Object.keys(this.availableAppsWithVersions);
            //~ end of available Apps and Version
            this.coresList = test.sort((a, b) => a - b);
            this.navService.sendLastUpdate(
              this._headerService.getUserNewDate()
            );
            if (this.toShow == false) {
              this.arrangeJobs();
            }
            if (this.updateJobDetail) {
              if (this.tempJobName != this.jobs[0].name) {
                this.tempJobName = this.jobs[0].name;
                this.jobNodeName = this.jobs[0].nodelist
                  ? this.jobs[0].nodelist.split(",")[0]
                  : "";
                this.navService.sendChildData(this.depName);
                this.validateSyncstoreDir(
                  this.jobs[0].outputDirectory,
                  this.jobs[0].workDirectory
                );
                if (
                  (this.jobs[0].state == JobGlobalState.Active &&
                    this.jobs[0].stage == HpcJobStageNames.STAGE_JOB_EXECUTE) ||
                  (this.jobs[0].state == JobGlobalState.Active &&
                    this.jobs[0].stage == HpcJobStageNames.STAGE_JOB_SUBMIT)
                ) {
                  this.openJobWorkstore();
                } else if (this.jobs[0].state == JobGlobalState.Active) {
                  this.openJobDetails();
                } else {
                  this.openJobSyncstore();
                }
              }
              this.updateJobDetail = false;
              // this.resetFilter();
              this.highlightClickedJob = this.jobs[0].number;
            }
            if (this.filtersApplied) this.autoApplySort();
            this.isJobsAvailable(null);
          } else {
            this.jobs = [];
            this.isJobsAvailable(null);
            this.spinner.hide("jobListLoad");
          }
        },
        error: (error) => {
          this.spinner.hide("jobListLoad");
        },
      });
  }

  loadJobsPerUser(entries: number) {
    if (this.dataReloadSubscription) {
      this.dataReloadSubscription.unsubscribe();
    }
    this.loadJobSub = this.jobService
      .getJobPerUser(
        this.depName,
        this.filterUser,
        entries,
        this.allJobsForAllUsers,
        this.isQueryActive,
        this.queryString
      )
      .subscribe((data) => {
        if (data) {
          this.jobs = <Job[]>JSON.parse(JSON.stringify(data));
          this.jobsCopy = <Job[]>JSON.parse(JSON.stringify(data));
          this.filterArrangeUser();
          if (this.filtersApplied && (
            this.selectedStatuses.length > 0 ||
            this.filterApplication !== "All" ||
            this.filterCores !== "All" ||
            this.filterNodes !== "All"
          )) {
            this.updateJobEntriesForFilteredData();
          }
          this.dataReloadSubscription = interval(
            this.syncConfig.config.jobs.listReqInterval
          ).subscribe(() => {
            this.loadJobsPerUser(this.entries);
            this.navService.sendLastUpdate(
              this._headerService.getUserNewDate()
            );
          });
          if (this.filtersApplied) this.autoApplySort();
          this.isJobsAvailable(this.jobs);
        } else {
          this.jobs = [];
          this.isJobsAvailable(this.jobs);
        }
      });
  }

  applyFilter() {
    this.filterArrangeUser();
    this.spinner.show("jobListLoad");
    this.filtersApplied = true;
    this.serialNoSort = false;
    this.jobSort = false;
    this.coresSort = false;
    this.timeCreateSort = false;
    this.timeEndSort = false;
    this.userSort = false;

    if (
      this.filterUser == "All" &&
      this.selectedStatuses.length === 0 &&  
      this.filterApplication == "All" &&
      this.filterCores == "All" &&
      this.filterNodes == "All" &&
      this.filterNodeGroup == "All" &&
      this.filterVersion == "All"
    ) {
      this.handleAllFilters();
    } else {
      if (this.filterUser != "All" && this.previousFilterUser != this.filterUser) {
        this.handleUserFilter();
      } else {
        this.handleOtherFilters();
      }
    }
  }

  resetAppVersion() {
    this.filterVersion = "All";
  }

  filterArrangeUser() {
    let filteredJobs = [...this.jobs];
    if (this.filterUser && this.filterUser !== "All") {
      filteredJobs = filteredJobs.filter((job) =>
        job.user
          .toLocaleLowerCase()
          .includes(this.filterUser.toLocaleLowerCase())
      );
    }
    if (this.selectedStatuses.length > 0) {
      filteredJobs = filteredJobs.filter(
        (job) =>
          this.selectedStatuses.includes(job.status) ||
          this.selectedStatuses.includes(job.state) ||
          (this.selectedStatuses.includes("Hold") ? job.isHeld == true : false) ||
          (this.selectedStatuses.includes("Queued") ? job.status.indexOf("Queued") != -1 : false)
      );
    }
    const isSucceededSelected = this.selectedStatuses.includes("Succeeded");
    const isHoldSelected = this.selectedStatuses.includes("Hold");
    if (isHoldSelected && isSucceededSelected) {
      filteredJobs = filteredJobs.filter(
        (job) =>
          job.isHeld === true ||
          (job.status === "Succeeded" && job.isHeld === false)
      );
    } else if (isSucceededSelected) {
      filteredJobs = filteredJobs.filter((job) => job.isHeld === false);
    }
    if (this.filterApplication && this.filterApplication !== "All") {
      filteredJobs = filteredJobs.filter((job) =>
        job.application
          .toLocaleLowerCase() == this.filterApplication.toLocaleLowerCase()
      );
    }
    if (this.filterVersion != "All") {
      filteredJobs = filteredJobs.filter((res) =>
        res.version?.match(this.filterVersion)
      );
    }
    if (this.filterCores && this.filterCores !== "All") {
      filteredJobs = filteredJobs.filter(
        (job) => job.maxCores === Number(this.filterCores)
      );
    }
    if (this.filterNodes != "All") {
      filteredJobs = filteredJobs.filter((job) =>
        job.nodelist
          ?.split(",")
          .some((node) => node.trim().toLowerCase() === this.filterNodes.trim().toLowerCase())
      );
    }
    if (this.filterNodeGroup != "All") {
      filteredJobs = filteredJobs.filter((job) =>
        job.partition
          ?.split(",")
          .some(
            (node) => node.trim().toLowerCase() === this.filterNodeGroup.trim().toLowerCase()
          )
      );
    }

    if (this.dateTimePeriod?.value && this.endDate != null) {
      let startDate = formatDate(
        new Date(this.dateTimePeriod.value[0]),
        "dd/MM/yy",
        "en-US"
      )
        .split("/")
        .join("-");
      let endDate = formatDate(
        new Date(this.dateTimePeriod.value[1]),
        "dd/MM/yy",
        "en-US"
      )
        .split("/")
        .join("-");
      let startDateObj = new Date(
        "20" + startDate.split("-").reverse().join("-")
      );
      let endDateObj = new Date("20" + endDate.split("-").reverse().join("-"));
      filteredJobs = filteredJobs.filter((job) => {
        const jobDate = this.formatDate(job.startTime);
        return jobDate >= startDateObj && jobDate <= endDateObj;
      });
    }

    this.jobs = filteredJobs;
  }

  private async handleAllFilters() {
    this.dataReloadSubscription?.unsubscribe();

    await lastValueFrom(this.getJobCountForUser());
    this.previousFilterUser = this.filterUser;
    this.loadPerUserJobs$.next(this.entries);
    this.setupDataReloadSubscription();
  }

  private async handleUserFilter() {
    // Refresh job count for user filter changes
    await lastValueFrom(this.getJobCountForUser());
    this.previousFilterUser = this.filterUser;

    this.loadJobsPerUser(this.entries);
  }

  private handleOtherFilters() {
    this.dataReloadSubscription?.unsubscribe();
    if (this.entries === 0) {
      this.entries = this.jobRetrievalRange;
    }

    this.loadJobSub = this.jobService
      .getJobPerUser(
        this.depName,
        this.filterUser,
        this.entries,
        this.allJobsForAllUsers,
        this.isQueryActive,
        this.queryString
      )
      .subscribe((data) => {
        if (data) {
          this.jobs = <Job[]>JSON.parse(JSON.stringify(data));

          this.jobsCopy = <Job[]>JSON.parse(JSON.stringify(data));
          this.filterArrangeUser(); // Call the filter function here to apply all filters
          this.updateJobEntriesForFilteredData();

          if (this.filterStatus != "All") {
            this.jobs = this.jobs.filter(
              (res) =>
                this.statusItems.includes(res.status) ||
                this.statusItems.includes(res.state)
            );
          }

          if (this.filterApplication != "All") {
            this.jobs = this.jobs.filter((res) => 
              res.application
                .toLocaleLowerCase()
                .match(this.filterApplication.toLocaleLowerCase())
            );
          }

          if (this.filterVersion != "All") {
            this.jobs = this.jobs.filter((res) =>
              res.version?.match(this.filterVersion)
            );
          }

          if (this.filterCores != "All") {
            this.jobs = this.jobs.filter((res) =>
              res.maxCores.toString().match(this.filterCores)
            );
          }

          if (this.filterNodes != "All") {
            this.jobs = this.jobs.filter((res) =>
              res.nodelist.toString().match(this.filterNodes)
            );
          }

          if (this.filtersApplied) this.autoApplySort();
          this.isJobsAvailable(this.jobs);
        }
        this.spinner.hide("jobListLoad");
      });
  }
  private updateJobEntriesForFilteredData() {
    const filteredCount = this.jobs.length;
    this.jobEntries = [filteredCount];
    this.jobCount = filteredCount;
    this.entries = filteredCount;
    this.startRange = 1;
  }

  private setupDataReloadSubscription() {
    this.dataReloadSubscription = interval(
      this.syncConfig.config.jobs.listReqInterval
    ).subscribe(() => {
      // this.loadJobsData(this.entries);
      this.loadPerUserJobs$.next(this.entries);
      this.navService.sendLastUpdate(this._headerService.getUserNewDate());
      this.isJobsAvailable(this.jobs);
    });
  }

  isJobsAvailable(jobs) {
    if (!this.jobs || this.jobs.length == 0) {
      this.available = false;
      this.toShow = false;
      this.spinner.hide("jobListLoad");
    } else {
      this.available = true;
      this.toShow = true;
      // while ((this.config.currentPage - 1) * 7 > this.jobs.length) {
      //   this.config.currentPage--;
      // }
    }
    if (!this.editQuerySpinnerFlag)
      // This is to prevent pending request to hide the spinner, it should only hide when desired data is loaded (Only for editQuery)
      this.spinner.hide("jobListLoad");
  }

  sortSrNo() {
    this.serialNoSort = !this.serialNoSort;
    this.activeSort = "id";
    this.jobSort = false;
    this.coresSort = false;
    this.timeCreateSort = false;
    this.timeEndSort = false;
    this.filtersApplied = true;
    this.userSort = false;
    if (this.serialNoSort) {
      this.sortLoadData();
    } else {
      this.jobs = this.jobs.sort((a, b) => 0 - (b.number < a.number ? 1 : -1));
    }
  }

  sortJobs() {
    this.jobSort = !this.jobSort;
    this.activeSort = "jobName";
    this.serialNoSort = false;
    this.coresSort = false;
    this.timeCreateSort = false;
    this.timeEndSort = false;
    this.filtersApplied = true;
    this.userSort = false;
    if (this.jobSort == true) {
      this.sortLoadData();
    } else {
      this.jobs = this.jobs.sort(
        (a, b) => 0 - (a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1)
      );
    }
  }

  sortUsers() {
    this.userSort = !this.userSort;
    this.activeSort = "users";
    this.jobSort = false;
    this.serialNoSort = false;
    this.coresSort = false;
    this.timeCreateSort = false;
    this.timeEndSort = false;
    this.filtersApplied = true;
    if (this.userSort == true) {
      this.sortLoadData();
    } else {
      this.jobs = this.jobs.sort(
        (a, b) => 0 - (a.user.toLowerCase() > b.user.toLowerCase() ? 1 : -1)
      );
    }
  }

  sortCores() {
    this.coresSort = !this.coresSort;
    this.activeSort = "cores";
    this.serialNoSort = false;
    this.jobSort = false;
    this.timeCreateSort = false;
    this.timeEndSort = false;
    this.filtersApplied = true;
    this.userSort = false;
    if (this.coresSort == true) {
      this.sortLoadData();
    } else {
      this.jobs = this.jobs.sort(
        (a, b) => 0 - (b.maxCores < a.maxCores ? 1 : -1)
      );
    }
  }

  sortLoadData() {
    if (this.serialNoSort) {
      this.jobs = this.jobs.sort((a, b) => 0 - (b.number > a.number ? 1 : -1));
    }
    if (this.jobSort) {
      this.jobs = this.jobs.sort(
        (a, b) => 0 - (b.name.toLowerCase() > a.name.toLowerCase() ? 1 : -1)
      );
    }
    if (this.coresSort) {
      this.jobs = this.jobs.sort(
        (a, b) => 0 - (b.maxCores > a.maxCores ? 1 : -1)
      );
    }
    if (this.userSort) {
      this.jobs = this.jobs.sort(
        (a, b) => 0 - (b.user.toLowerCase() > a.user.toLowerCase() ? 1 : -1)
      );
    }
    if (this.timeCreateSort) {
      this.jobs.sort(
        (a, b) =>
          new Date(a.startTime).getTime() - new Date(b.startTime).getTime()
      );
    }
    if (this.timeEndSort) {
      this.jobs.sort(
        (a, b) =>
          new Date(a.endTime).getTime() - new Date(b.startTime).getTime()
      );
    }
  }

  sortByCreateTime() {
    this.timeCreateSort = !this.timeCreateSort;
    this.activeSort = "time";
    this.serialNoSort = false;
    this.jobSort = false;
    this.coresSort = false;
    this.filtersApplied = true;
    this.timeEndSort = false;
    this.userSort = false;
    if (this.timeCreateSort) {
      this.sortLoadData();
    } else {
      this.jobs.sort(
        (a, b) =>
          new Date(b.startTime).getTime() - new Date(a.startTime).getTime()
      );
    }
  }

  sortByRunTime() {
    this.timeSort = !this.timeSort;
    this.serialNoSort = false;
    this.jobSort = false;
    this.coresSort = false;
    this.filtersApplied = true;
    this.timeCreateSort = false;
    this.userSort = false;
    this.timeEndSort = false;

    this.jobs.sort((a, b) => {
      // Parse dynamic time format into total seconds
      const toSeconds = (timeStr: string): number => {
        if (!timeStr || timeStr === "-") {
          return -1;        }
        const parts = timeStr.split(":").map(Number);

        if (parts.length === 2) {
          return parts[0] * 60 + parts[1]; 
        } else if (parts.length === 3) {
          return parts[0] * 3600 + parts[1] * 60 + parts[2];
        } else if (parts.length === 4) {
          return parts[0] * 24 * 3600 + parts[1] * 3600 + parts[2] * 60 + parts[3];
        }

        return -1; 
      };

      const aSeconds = toSeconds(a.runTime);
      const bSeconds = toSeconds(b.runTime);

      if (aSeconds === -1) return 1; 
      if (bSeconds === -1) return -1;

      return this.timeSort
        ? aSeconds - bSeconds // Ascending
        : bSeconds - aSeconds; // Descending
    });
  }

  sortByEndTime() {
    this.timeEndSort = !this.timeEndSort;
    this.activeSort = "time";
    this.serialNoSort = false;
    this.jobSort = false;
    this.coresSort = false;
    this.filtersApplied = true;
    this.timeCreateSort = false;
    this.userSort = false;
    if (this.timeEndSort) {
      this.sortLoadData();
    } else {
      this.jobs.sort(
        (a, b) =>
          new Date(b.startTime).getTime() - new Date(a.startTime).getTime()
      );
    }
  }

  async resetFilter() {
    this.resetSortFilter();
    if (this.dataReloadSubscription) {
      this.dataReloadSubscription.unsubscribe();
    }
    this.activeSort = "none";
    this.filtersApplied = false;
    this.isQueryActive = false;
    this.queryString = "";
    this.selectedStatuses = [];
    this.endDate = null;
    if (this.dateTimePeriod?.value) {
      this.dateTimePeriod.reset(null);
    }
    // this.loadJobsData(this.entries);
    this.loadPerUserJobs$.next(this.entries);
    this.dataReloadSubscription = interval(
      this.syncConfig.config.jobs.listReqInterval
    ).subscribe(() => {
      // this.loadJobsData(this.entries);
      this.loadPerUserJobs$.next(this.entries);
      this.navService.sendLastUpdate(this._headerService.getUserNewDate());
    });
    const x = await lastValueFrom(this.getJobCountForUser());
  }

  loadJobDataForRange(entries) {
    if (this.entries == this.jobRetrievalRange) {
      this.startRange = 1;
    } else if (this.entries == this.jobCount) {
      let lastEntry = Number(
        Math.floor(this.jobCount / this.jobRetrievalRange) *
        this.jobRetrievalRange
      );
      this.startRange =
        lastEntry == this.jobCount
          ? lastEntry - this.jobRetrievalRange + 1
          : lastEntry + 1;
    } else {
      this.startRange = Number(this.entries - this.jobRetrievalRange) + 1;
    }
    this.spinner.show("jobListLoad");
    // this.loadJobsData(entries);
    this.loadPerUserJobs$.next(this.entries);
    this.filtersApplied = false;
  }

  resetSortFilter() {
    this.spinner.show("jobListLoad");
    this.serialNoSort = false;
    this.jobSort = false;
    this.coresSort = false;
    this.timeCreateSort = false;
    this.timeEndSort = false;
    this.userSort = false;
    this.filterApplication = "All";
    this.filterVersion = "All";
    this.filterStatus = "All";
    this.filterCores = "All";
    this.filterNodes = "All";
    this.filterNodeGroup = "All";
    if (this.authenticationService.loggedIn()) {
      if (this.filterUser != this.currentUser)
        this.filterUser = this.getInitialFilterUser();
    }
  }

  createJobNameSuggestions(appName: string) {
    let userName = this.authenticationService.currentUserValue.username;
    let suggestions = [userName, this.depName, appName];
    let jobs: Job[];
    if (!this.jobs) return suggestions;
    jobs = this.jobs.filter((res) => {
      return res.application.toLowerCase().match(appName);
    });

    let jobName: string;
    for (let a of jobs) {
      if (!a.name.includes(appName.toLowerCase() && "-")) {
        jobName = a.name.split("_")[0];
        suggestions.push(jobName);
        break;
      }
    }
    var date = this._headerService.getUserNewDate();
    var transformDate = this.datePipe.transform(date, "dd-MMM");
    suggestions.forEach((element) => {
      suggestions.push(element + "-" + transformDate);
    });
    return suggestions;
  }

  getSyncStoreUsageData() {
    // this.universalSub = this.storageService
    //   .getSyncStoreUsage(this.depName, this.currentStorageName)
    //   .subscribe({
    //     next: (data: any) => {
    //       if (!data.usedStorage) return;
    //       if (data.totalStorage == 0) return;
    //       this.syncStoreUsage = `(${data.usedStorage} / ${data.totalStorage} GB)`;
    //     },
    //     error: (err) => {},
    //   });
  }

  getWorkStoreUsageData() {
    // this.universalSub = this.storageService
    //   .getWorkStoreUsage(this.depName, this.currentStorageName)
    //   .subscribe({
    //     next: (data: any) => {
    //       if (!data.usedStorage) return;
    //       if (data.totalStorage == 0) return;
    //       this.workStoreUsage = `(${data.usedStorage} / ${data.totalStorage} GB)`;
    //     },
    //     error: (err) => {},
    //   });
  }

  getHeadNodeIp() {
    this.storageService.getHeadNodeIp(this.depName).subscribe({
      next: (data: any) => {
        this.fileUploadHeadNodeIP = JSON.parse(JSON.stringify(data.vmIp));
        if (this.cloudType == CloudTypes.OnPremise) {
          this.utilityService
            .checkIfUtilityServiceActive(
              this.fileUploadHeadNodeIP,
              this.depName
            )
            .subscribe();
        }
      },
      error: (err) => { },
    });
  }

  onSearch() {
    if (this.filterText.length > 0) {
      this.filtersApplied = true;
    }
    this.jobs = [...this.jobsCopy].filter(
      (nd) =>
        nd.jobTag?.toLowerCase().includes(this.filterText.toLowerCase()) ||
        nd.name.toLowerCase().includes(this.filterText.toLowerCase())
    );
    this.config.currentPage = 1;
  }

  toggleStatusList(isOpen: boolean) {
    this.isDropdownOpen = isOpen;
    this.checkList = document.getElementById("list1");
    if (this.checkList.classList.contains("visible"))
      this.checkList.classList.remove("visible");
    else this.checkList.classList.add("visible");
  }

  checkboxHandler(event) {
    if (this.functionReference) {
      clearTimeout(this.functionReference);
    }
    if (event.srcElement.checked) {
      if (!this.statusItems.includes(event.target.value)) {
        this.statusItems.push(event.target.value);
      }
    } else {
      this.statusItems = this.statusItems.filter(
        (e) => e !== event.target.value
      );
    }
    this.functionReference = setTimeout(() => {
      this.toggleStatusList(false);
      if (this.statusItems.length === 0) {
        this.filterStatus = "All";
      } else {
        this.filterStatus = this.statusItems.join(", ");
      }
      this.applyFilter();
    }, 1500);
  }

  getColumnSetting() {
    this.userService.getColumnSetting(this.currentUser).subscribe((res) => {
      if (res) {
        let s = JSON.parse(JSON.stringify(res));
        if (s.data != null) {
          let colInfo: UserSetting = <UserSetting>(
            JSON.parse(JSON.stringify(s.data))
          );
          const exists = colInfo?.columnSetting?.some(item => item?.tableName == this.tableName) || false;
          if (exists) {
            colInfo.columnSetting.forEach((e) => {
              if (e.tableName == this.tableName) {
                this.editedColumnList = e.columnInfo.split(",");
                this.columnInfo = {
                  ...this.columnInfo,
                  coloumToShow: [...this.editedColumnList],
                };
              }
            });
          }
          else {
            this.editedColumnList = [
              "Application",
              "#Cores",
              "BatchNode",
              "UserGroup",
              "Status",
              "User",
              "Global State",
              "Stage",
            ];
            this.columnInfo = {
              ...this.columnInfo,
              coloumToShow: [...this.editedColumnList],
            };
          }
        } else {
          this.editedColumnList = [
            "Application",
            "#Cores",
            "BatchNode",
            "UserGroup",
            "Status",
            "User",
            "Global State",
            "Stage",
          ];
          this.columnInfo = {
            ...this.columnInfo,
            coloumToShow: [...this.editedColumnList],
          };
        }
      } else {
        this.editedColumnList = [
          "Application",
          "#Cores",
          "BatchNode",
          "UserGroup",
          "Status",
          "User",
          "Global State",
          "Stage",
        ];
        this.columnInfo = {
          ...this.columnInfo,
          coloumToShow: [...this.editedColumnList],
        };
      }
    });
  }

  editColoum() {
    const editColumnDailog = this.dialog.open(EditColoumsComponent, {
      autoFocus: false,
      disableClose: true,
      width: "400px",
      data: {
        columnsFromComponents: [...this.columnInfo.columnsOfComponents],
        previoslySelectedColumns: [...this.columnInfo.coloumToShow],
      },
    });
    editColumnDailog.afterClosed().subscribe((res) => {
      if (res.status) {
        if (res.data != null && res.data.length >= 0) {
          let columsName = res.data.map((el) => el.name);
          let columsNameString = columsName.join(",");
          this.userService
            .updateUserColumnSetting(
              this.currentUser,
              columsNameString,
              this.tableName
            )
            .subscribe((data) => {
              if (data) {
                let response = JSON.parse(JSON.stringify(data));
                if (response.status == 200) {
                  this.editedColumnList = columsNameString.split(",");
                  this.columnInfo = {
                    ...this.columnInfo,
                    coloumToShow: [...this.editedColumnList],
                  };
                  this.snackBar.open(response.actionMessage, "Ok", {
                    duration: 5000,
                  });
                } else if (response.status != 200) {
                  this.snackBar.open(response.actionMessage, "Ok", {
                    duration: 5000,
                  });
                }
              }
            });
        }
      }
    });
  }

  editQuery() {
    this.dataReloadSubscription?.unsubscribe();
    this.loadJobSub?.unsubscribe();
    const editColumnDailog = this.dialog
      .open(EditQueryComponent, {
        autoFocus: false,
        disableClose: true,
        width: "700px",
        data: {
          userRole: this.userRole,
          userName: this.currentUser,
          filterUser: this.filterUser,
          filterStatus: this.filterStatus,
          filterApplication: this.filterApplication,
          isQueryActive: this.isQueryActive,
          queryString: this.queryString,
        },
      })
      .afterClosed()
      .subscribe((res) => {
        if (res.status === true) {
          this.isQueryActive = true;
          this.queryString = res.query;
          this.spinner.show("jobListLoad");
          this.editQuerySpinnerFlag = true;
          this.loadPerUserJobs$.next(this.entries);
          // this.loadJobsData(this.entries);
          this.snackBar.open("Query Applied Successfully", "Ok", {
            duration: 5000,
          });
        }
        this.ngOnChanges();
      });
  }

  runCommand() {
    this.dialog.open(RunJobCommandComponent, {
      width: "50%",
      autoFocus: true,
      disableClose: true,
      id: "runJobCommand",
      data: {
        depName: this.depName,
        jobName: "",
        actionText: JobActionsText.TxtRunCommand,
        actionValue: JobActionsValue.ValRunCommand,
        runCommandFromJobActions: false,
        id: "runJobCommand",
      },
      panelClass: "run-command-dialog",
    });
  }

  getLocalWorkStoreName() {
    if (this.isLocalStoreEnabled) {
      let job: Job = this.jobs.find((job) => job.name == this.tempJobName);
      if (job) {
        if (job.stage == HpcJobStageNames.STAGE_JOB_EXECUTE) {
          return job.nodelist ? " - " + job.nodelist.split(",")[0] : "";
        }
      }
    }
  }

  reorderQueuedJobs() {
    this.dialog
      .open(ReorderQueuedJobsComponent, {
        width: "25%",
        autoFocus: true,
        disableClose: true,
        id: "reorderQueuedJobs",
        data: {
          depName: this.depName,
          id: "reorderQueuedJobs",
        },
        panelClass: "reorder-queued-jobs-dialog",
      })
      .afterClosed()
      .subscribe((res) => { });
  }

  getJobCount() {
    this.jobService
      .getJobCountService(
        this.depName,
        this.authenticationService.currentUserValue.role,
        this.filterUser,
        this.allJobsForAllUsers
      )
      .subscribe((data: any) => {
        this.jobEntries = data?.rangeCounts.split(",").map((c) => Number(c));
        this.jobCount = this.jobEntries[this.jobEntries.length - 1];
        this.jobRetrievalRange = this.jobEntries[0];
        this.entries = this.jobEntries[0];
        this.loadPerUserJobs$.next(this.jobEntries[0]);
      });
  }

  showAllEntriesMethod() {
    if (this.entriesNumber > 0) {
      this.config.itemsPerPage = this.entriesNumber;
    }
  }

  paginationEntries(event) {
    this.entriesNumber = event.target.value;
  }

  getJobCountForUser(): Observable<boolean> {
    return this.jobService
      .getJobCountService(
        this.depName,
        this.authenticationService.currentUserValue.role,
        this.filterUser,
        this.allJobsForAllUsers
      )
      .pipe(
        map((data: any) => {
          this.jobEntries = data?.rangeCounts.split(",").map((c) => Number(c));
          this.jobCount = this.jobEntries[this.jobEntries.length - 1];
          this.jobRetrievalRange = this.jobEntries[0];

          this.entries = this.jobEntries[0];
          if (this.entries == this.jobRetrievalRange) {
            this.startRange = 1;
          } else if (this.entries == this.jobCount) {
            let lastEntry = Number(
              Math.floor(this.jobCount / this.jobRetrievalRange) *
              this.jobRetrievalRange
            );
            this.startRange =
              lastEntry == this.jobCount
                ? lastEntry - this.jobRetrievalRange + 1
                : lastEntry + 1;
          } else {
            this.startRange = Number(this.entries - this.jobRetrievalRange) + 1;
          }
          return true; // returning boolean value
        }),
        catchError((err) => {
          return of(false); // returning boolean value
        })
      );
  }

  toggleFilters() {
    this.toShowFilter = !this.toShowFilter;
  }

  refreshComponent() {
    let url = this.router.url;
    this.jobService.updateJobAction(null);
    this.router.navigateByUrl("/", { skipLocationChange: true }).then(() => {
      this.router.navigate([decodeURI(url)]);
    });
  }

  extractBatchNode(input: string): string {
    if (!input) return input;
    const pattern = /(\w+)\\?\[?(\d+)(?:-\d+)?\]?:?\d+/;
    const match = input.replace(",", "-").match(pattern);

    if (match) {
      const prefix = match[1];
      const number = match[2];
      return `${prefix}${number}`;
    }

    return input;
  }

  importJobs() {
    const dialogRef = this.dialog.open(ImportJobsComponent, {
      autoFocus: false,
      disableClose: true,
      width: "600px",
      data: {
        importType: ImportCSVType.Jobs,
        requiredParams:
          "JobId, UserId, NumberOfCores, Application, AllocatedNodes, CreateTime, StartTime, EndTime, Partition, State",
        uniqueFields: "JobId",
        depName: this.depName,
      },
    });
    dialogRef.afterClosed().subscribe((res) => {
      if (res) {
        this.refreshComponent();
      }
    });
  }

  trackJob(job: Job, index: number) {
    const updatedJob = this.jobs.find((j) => j.name === job.name);
    if (!updatedJob) return false;
    return (
      job.state !== updatedJob.state ||
      job.status !== updatedJob.status ||
      job.stage !== updatedJob.stage
    );
  }

  getActiveFiltersCount(): number {
    let count = 0;
    if (this.filterUser !== this.currentUser) {
      if (!this.isGlobalAdmin || this.filterUser != "All") {
        count++;
      }
    }
    if (this.selectedStatuses?.length > 0) count++;
    if (this.filterCores !== "All") count++;
    if (this.filterApplication !== "All") count++;
    if (this.filterVersion !== "All") count++;
    if (this.filterNodes !== "All") count++;
    if (this.filterNodeGroup !== "All") count++;
    if (this.dateTimePeriod.value) count++;
    return count;
  }

  onPageChange(event) {
    this.config.currentPage = event;

    // reason of setTimeOut is i want to check or uncheck the checkboxs after the page change
    setTimeout(() => {
      const elements: HTMLInputElement[] = Array.from(
        document.querySelectorAll<HTMLInputElement>(".multiJobSelect")
      );
      elements.forEach((checkbox) => {
        if (this.selectedJobIds.includes(checkbox.name))
          checkbox.checked = true;
        else {
          checkbox.checked = false;
        }
      });

      this.updateCheckboxSelectedList();
      const selectAll: HTMLInputElement =
        document.querySelector<HTMLInputElement>(".selectAll");
      if (this.checkIfAllSelected()) selectAll.checked = true;
      else selectAll.checked = false;
    }, 0);
  }

  checkIfAllSelected() {
    let flag = true;
    const elements: HTMLInputElement[] = Array.from(
      document.querySelectorAll<HTMLInputElement>(".multiJobSelect")
    );
    elements.forEach((checkbox) => {
      if (!checkbox.checked) flag = false;
    });
    return flag;
  }

  wholePageJobs(event) {
    const elements: HTMLInputElement[] = Array.from(
      document.querySelectorAll<HTMLInputElement>(".multiJobSelect")
    );
    if (event.target.checked) {
      elements.forEach((checkbox) => {
        if (!this.selectedJobIds.includes(checkbox.name))
          this.selectedJobIds.push(checkbox.name);
      });

      elements.forEach((checkbox) => {
        if (this.selectedJobIds.includes(checkbox.name))
          checkbox.checked = true;
      });
    } else {
      elements.forEach((checkbox) => {
        if (this.selectedJobIds.includes(checkbox.name))
          this.selectedJobIds.splice(
            this.selectedJobIds.indexOf(checkbox.name),
            1
          );
      });
      elements.forEach((checkbox) => (checkbox.checked = false));
    }
  }

  updateSelectedList(job, event) {
    if (event.target.checked) {
      this.selectedJobIds.push(job.name);
    } else {
      this.selectedJobIds = this.selectedJobIds.filter(
        (name) => name !== job.name
      );
    }
    const selectAll: HTMLInputElement =
      document.querySelector<HTMLInputElement>(".selectAll");
    if (this.checkIfAllSelected()) selectAll.checked = true;
    else selectAll.checked = false;
    this.updateCheckboxSelectedList();
  }

  updateCheckboxSelectedList() {
    const elements: HTMLInputElement[] = Array.from(
      document.querySelectorAll<HTMLInputElement>(".multiJobSelect")
    );
    elements.forEach((e) => (e.checked = this.selectedJobIds.includes(e.name)));
    const selectAll: HTMLInputElement =
      document.querySelector<HTMLInputElement>(".selectAll");
    if (selectAll) {
      if (this.checkIfAllSelected()) selectAll.checked = true;
      else selectAll.checked = false;
    }
  }

  collectiveOptionsAction(actionText: string) {
    let actionValue: number = -1;
    const elements: HTMLInputElement[] = Array.from(
      document.querySelectorAll<HTMLInputElement>(".multiJobSelect")
    );
    let snackbarmessage = null;
    let allSelectedCount = this.selectedJobIds.length;
    if (actionText === "Delete") {
      actionValue = 11;
      this.selectedJobIds = this.jobs
        .filter(
          (job) =>
            this.selectedJobIds.includes(job.name) && job.state === "Inactive"
        )
        .map((job) => job.name);
      if (this.selectedJobIds.length != allSelectedCount) {
        snackbarmessage = "Only Inactive Jobs will be deleted";
      }
    } else if (actionText === "Cancel" || actionText === "ForceInactive") {
      actionValue = actionText === "Cancel" ? 0 : 24;
      this.selectedJobIds = this.jobs
        .filter(
          (job) =>
            this.selectedJobIds.includes(job.name) && job.state === "Active"
        )
        .map((job) => job.name);

      if (this.selectedJobIds.length != allSelectedCount) {
        let message = "Only Active Jobs will be Canceled";

        if (actionText === "ForceInactive") {
          message =
            "Only Active Jobs Which are in Cancelling State will be Froced Inactive";
        }

        snackbarmessage = message;
      }
    }

    this.updateCheckboxSelectedList();

    elements.forEach((checkbox) => {
      if (!this.selectedJobIds.includes(checkbox.name))
        checkbox.checked = false;
    });
    const selectAll: HTMLInputElement =
      document.querySelector<HTMLInputElement>(".selectAll");
    if (this.checkIfAllSelected()) selectAll.checked = true;
    else selectAll.checked = false;

    if (this.selectedJobIds.length != 0) {
      const dialogRef = this.dialog.open(JobConfirmationDialogComponent, {
        width: "35%",
        autoFocus: true,
        disableClose: true,
        data: {
          depName: this.depName,
          jobName: this.selectedJobIds.join(","),
          actionText: actionText,
          actionValue: actionValue,
          title: actionText + " Jobs",
          message: "Do you want to ",
          noBtnText: "No",
          yesBtnText: "Yes",
          snackBarMessage: snackbarmessage,
        },
      });
      dialogRef.afterClosed().subscribe((res) => {
        this.selectedJobIds = [];
        elements.forEach((checkbox) => (checkbox.checked = false));

        if (actionText === "Delete") this.jobService.triggerJobDeletion();

        this.reloadJobListAfterDialogClosed(res, true);

        const selectAll: HTMLInputElement =
          document.querySelector<HTMLInputElement>(".selectAll");
        if (this.checkIfAllSelected()) selectAll.checked = true;
        else selectAll.checked = false;
      });
    } else {
      this.snackBar.open(snackbarmessage, "Ok", {
        duration: 5000,
      });
    }
  }

  maximizeView(value) {
    if (value == 100) {
      const expandIcon = document.querySelector(".expandedTheMenu");
      if (expandIcon) {
        const toggleDiv = document.querySelector(".toggleMenuToCollapse");
        if (toggleDiv) {
          (toggleDiv as HTMLElement).click();
        }
      }
    }
    this.advancedViewLength = value;
  }

  getDataOfNodeGroup(nodes) {
    return nodes?.split(",");
  }
}
